import { all, put, fork, takeEvery, select, delay, take } from 'redux-saga/effects';
import actions from './actions';
import toolsAction from '../tools/actions';
import settlementActions from '../settlement/actions';
import mqttActions from '../mqtt/actions';

import { post, PUT, get, DELETE } from '@iso/lib/helpers/resApiRequestor';
import {
  // filterDuplicateTransactitonData,
  // filterDuplicateTransactionDataWithAmount,
  filterDuplicateData
} from '@iso/lib/helpers/utility';
import moment from 'moment';

export function* search() {
  yield takeEvery('SEARCH', function* ({ payload }) {
    try {
      if (payload.keyword) {
        yield put({
          type: actions.START_SEARCH,
          keyword: payload.keyword
        });
        yield put({
          type: actions.LOADING_TRANSACTIONS
        });
        const apiResult = yield searchRequest(payload);
        const result = apiResult.data;
        yield put({
          type: actions.TRANSACTIONS_LOADED,
          transactions: result.data,
          scrollId: result.scrollId,
          transactionCount: result.totalCount
        });
        // yield put({
        //   type: actions.SET_CURRENT_TRANSACTION,
        //   payload: result.data[0],
        // });
        yield put({
          type: actions.END_SEARCH,
          keyword: payload.keyword,
          searchValue: result.data[0]
        });
      }
    } catch (error) {
      // yield delay(5000);
      yield put({
        type: actions.END_SEARCH,
        keyword: null
      });
    }
  });
}
export function* fetchCaseLogs() {
  yield takeEvery('FETCH_CASE_LOGS', function* ({ payload, pagination }) {
    try {
      const loadmore = pagination.loadMore;
      if (loadmore) {
        yield put({
          type: actions.LOADING_MORE_CASE_LOGS
        });
      } else {
        yield put({
          type: actions.FETCHING_CASE_LOGS,
          loading: true
        });
      }
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchCaseLogsAPI(payload, pagination, roleHeaderAuth);
      const currentList = pagination.currentData && loadmore ? pagination.currentData : [];

      const result = apiResult.data;

      const parseData =
        currentList && currentList.length > 0
          ? currentList.concat(result.data.logs)
          : result.data.logs;

      const finalData = parseData ? filterDuplicateData(parseData) : [];

      if (result.success) {
        yield put({
          type: actions.FETCH_CASE_LOGS_SUCCESS,
          loading: false,
          result: finalData,
          pagination: result ? result.data.pagination : null
        });
      } else {
        yield put({
          type: actions.FETCH_CASE_LOGS_FAILED,
          loading: false,
          payload: currentList
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_CASE_LOGS_FAILED,
        loading: false,
        payload: []
      });
    }
  });
}
export function* unsubscribeNotificationCredential() {
  yield takeEvery('UNSUBSCRIBE_NOTIFICATION_CREDENTIAL', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.UNSUBSCRIBING_NOTIFICATION_CREDENTIAL,
        loading: true
      });
      const apiResult = yield unsubscribeNotificationCredentialAPI(payload, id, null);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.UNSUBSCRIBE_NOTIFICATION_CREDENTIAL_SUCCESS,
          loading: false,
          message: result.message,
          redirectUrl: '/unsubscribe_success'
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.UNSUBSCRIBE_NOTIFICATION_CREDENTIAL_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false,
            redirectUrl: '/unsubscribe_failed'
          });
        } else {
          yield put({
            type: actions.UNSUBSCRIBE_NOTIFICATION_CREDENTIAL_FAILED,
            message: result.message,
            loading: false,
            redirectUrl: '/unsubscribe_failed'
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.UNSUBSCRIBE_NOTIFICATION_CREDENTIAL_FAILED,
        message: 'Failed to process request',
        loading: false,
        redirectUrl: '/unsubscribe_failed'
      });
    }
  });
}
export function* getURLSforUploadedCaseFiles() {
  yield takeEvery('STORE_ATTACHED_CASE_FILES_FOR_UPLOAD', function* ({ key, files }) {
    try {
      yield put({
        type: actions.STORING_ATTACHED_CASE_FILES_FOR_UPLOAD,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield getURLsForCaseFilesAPI(key, files, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.STORE_ATTACHED_CASE_FILES_FOR_UPLOAD_SUCCESS,
          loading: false,
          result: result ? result.data : null
        });
      } else {
        yield put({
          type: actions.STORE_ATTACHED_CASE_FILES_FOR_UPLOAD_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.STORE_ATTACHED_CASE_FILES_FOR_UPLOAD_FAILED,
        loading: false
      });
    }
  });
}
export function* sendDiscussion() {
  yield takeEvery('SEND_DISCUSSION_ITEM', function* ({ urls, payload }) {
    try {
      yield put({
        type: actions.SENDING_DISCUSSION_ITEM,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const state = yield select();
      const caseDiscussionData = state.Transaction.caseDiscussionData;
      let finalDataForUpload = [];
      if (payload && payload.files.length === urls.length) {
        const dataFile = payload.files;
        dataFile.forEach(file => {
          if (urls.some(str => str.includes(file.name))) {
            let getURL = urls.find(str => str.includes(file.name));
            if (getURL) {
              uploadFileToS3(getURL, file);
              let currentObj = {
                name: file.name,
                file_type: file.file_type
              };
              finalDataForUpload.push(currentObj);
            }
          }
        });

        yield delay(urls.length * 1000);
      }
      if (payload.case_id) {
        const apiResult = yield sendDiscussionAPI(
          {
            files: finalDataForUpload,
            case_id: payload.case_id,
            reply_to: payload.reply_to,
            mentions: payload.mentions,
            message: payload.message,
            module: payload.module,
            topic: payload.topic,
            notification_data: payload.notification_data
          },
          roleHeaderAuth
        );
        const result = apiResult.data;
        if (result.success) {
          yield put({
            type: actions.SEND_DISCUSSION_ITEM_SUCCESS,
            loading: false,
            message: result.message
          });
          if (payload && payload.case_id && caseDiscussionData) {
            yield put({
              type: actions.FETCH_CASE_DISCUSSIONS,
              payload: {
                case_id: payload.case_id
              },
              currentList: caseDiscussionData
            });
          }
        } else {
          if (result.status === 404) {
            yield put({
              type: actions.SEND_DISCUSSION_ITEM_FAILED,
              message: `Endpoint ${result.title}`,
              loading: false
            });
          } else if (result.status === 413) {
            yield put({
              type: actions.SEND_DISCUSSION_ITEM_FAILED,
              message: `Your request exceeded the system limit size`,
              loading: false
            });
          } else {
            yield put({
              type: actions.SEND_DISCUSSION_ITEM_FAILED,
              message: result.message,
              loading: false
            });
          }
        }
      } else {
        yield put({
          type: actions.SEND_DISCUSSION_ITEM_FAILED,
          message: `Your message failed to send due to an issue. Please try again later`,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.UPLOAD_MULTIPLE_FILE_TRANSACTION_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* likeDiscussion() {
  yield takeEvery('LIKE_DISCUSSION_DATA', function* ({ id, payload }) {
    try {
      yield put({
        type: actions.LIKING_TRANSACTION_DATA,
        loading: true
      });

      yield put({
        type: actions.LIKE_CURRENT_ID,
        payload: id
      });

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield likeDiscussionAPI(id, payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.LIKE_DISCUSSION_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        if (payload && payload.case_id) {
          yield put({
            type: actions.FETCH_CASE_LOGS,
            payload: payload.case_id,
            pagination: {
              page: 0,
              limit: 10
            }
          });
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.LIKE_DISCUSSION_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.LIKE_DISCUSSION_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.LIKE_DISCUSSION_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* downloadCaseAttachment() {
  yield takeEvery('DOWNLOAD_CASE_DISCUSSION_ATTACHMENT', function* ({ payload }) {
    try {
      yield put({
        type: actions.DOWNLOADING_CASE_DISCUSSION_ATTACHMENT,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield downloadCaseAttachmentAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.DOWNLOAD_CASE_DISCUSSION_ATTACHMENT_SUCCESS,
          loading: false,
          message: 'Attachment downloaded successfully.'
        });
        if (result.url) {
          window.open(result.url, '_blank');
          // window.location.href = result.url;
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.DOWNLOAD_CASE_DISCUSSION_ATTACHMENT_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.DOWNLOAD_CASE_DISCUSSION_ATTACHMENT_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.DOWNLOAD_CASE_DISCUSSION_ATTACHMENT_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* fetchCaseDiscussions() {
  yield takeEvery('FETCH_CASE_DISCUSSIONS', function* ({ payload, currentList }) {
    try {
      if (payload && payload.loadMore) {
        yield put({
          type: actions.LOAD_MORE_CASE_DISCUSSIONS,
          loading: true
        });
      } else {
        yield put({
          type: actions.FETCHING_CASE_DISCUSSIONS,
          loading: true
        });
      }

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchCaseDiscussionAPI(payload, roleHeaderAuth);
      const result = apiResult.data;

      const listData = currentList && payload.loadMore && currentList.length > 0 ? currentList : [];
      const parseData =
        listData && listData.length > 0 ? listData.concat(result.data) : result.data;
      const finalData = filterDuplicateData(parseData);

      if (result.success) {
        yield put({
          type: actions.FETCH_CASE_DISCUSSIONS_SUCCESS,
          loading: false,
          result: finalData,
          pagination: result.pagination,
          filter: {
            ...payload
          }
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_CASE_DISCUSSIONS_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.FETCH_CASE_DISCUSSIONS_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_CASE_DISCUSSIONS_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* fetchReconciliationDataByPChannelID() {
  yield takeEvery('FETCH_RECONCILIATION_DATA_BY_PCHANNEL', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_RECONCILIATION_DATA_BY_PCHANNEL,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchReconciliationDataByPChannelIDAPI(payload, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.FETCH_RECONCILIATION_DATA_BY_PCHANNEL_SUCCESS,
          loading: false,
          result: result && result.data ? result.data : null,
          filter: payload
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_RECONCILIATION_DATA_BY_PCHANNEL_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false,
            result: null,
            filter: payload
          });
        } else {
          yield put({
            type: actions.FETCH_RECONCILIATION_DATA_BY_PCHANNEL_FAILED,
            message: 'Failed to process request',
            loading: false,
            result: null,
            filter: payload
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_RECONCILIATION_DATA_BY_PCHANNEL_FAILED,
        loading: false,
        message: 'Failed to process request',
        result: null,
        filter: payload
      });
    }
  });
}
export function* fetchBillingDataByMerchantID() {
  yield takeEvery('FETCH_BILLING_DATA_BY_MERCHANT', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_BILLING_DATA_BY_MERCHANT,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchBillingDataByMerchantIDAPI(payload, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.FETCH_BILLING_DATA_BY_MERCHANT_SUCCESS,
          loading: false,
          result: result && result.data ? result.data : null,
          filter: payload
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_BILLING_DATA_BY_MERCHANT_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false,
            result: null
          });
        } else {
          yield put({
            type: actions.FETCH_BILLING_DATA_BY_MERCHANT_FAILED,
            message: 'Failed to process request',
            loading: false,
            result: null
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_BILLING_DATA_BY_MERCHANT_FAILED,
        loading: false,
        message: 'Failed to process request',
        result: null
      });
    }
  });
}
export function* fetchResponseCode() {
  yield takeEvery('FETCH_RESPONSE_CODE', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_RESPONSE_CODE,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchResponseCodeAPI(roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_RESPONSE_CODE_SUCCESS,
          loading: false,
          result: result && result.data ? result.data : null
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_RESPONSE_CODE_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false,
            result: null
          });
        } else {
          yield put({
            type: actions.FETCH_RESPONSE_CODE_FAILED,
            message: 'Failed to process request',
            loading: false,
            result: null
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_RESPONSE_CODE_FAILED,
        loading: false,
        message: 'Failed to process request',
        result: null
      });
    }
  });
}
export function* addResponseCode() {
  yield takeEvery('ADD_RESPONSE_CODE', function* ({ payload }) {
    try {
      yield put({
        type: actions.ADDING_RESPONSE_CODE,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield addResponseCodeAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.ADD_RESPONSE_CODE_SUCCESS,
          loading: false,
          message: result.message
        });

        yield put({
          type: actions.FETCH_RESPONSE_CODE
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.ADD_RESPONSE_CODE_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.ADD_RESPONSE_CODE_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.ADD_RESPONSE_CODE_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* editResponseCode() {
  yield takeEvery('EDIT_RESPONSE_CODE', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.EDITING_RESPONSE_CODE,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield editResponseCodeAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.EDIT_RESPONSE_CODE_SUCCESS,
          loading: false,
          message: result.message
        });

        yield put({
          type: actions.FETCH_RESPONSE_CODE
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.EDIT_RESPONSE_CODE_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.EDIT_RESPONSE_CODE_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.EDIT_RESPONSE_CODE_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* editSettlementRate() {
  yield takeEvery('EDIT_SETTLEMENT_RATE', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.EDITING_SETTLEMENT_RATE,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield editSettlementRateAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.EDIT_SETTLEMENT_RATE_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_SETTLEMENT_RATE_BY_ID,
          payload: payload.settlement_cycle_id
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.EDIT_SETTLEMENT_RATE_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.EDIT_SETTLEMENT_RATE_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.EDIT_SETTLEMENT_RATE_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* changeResponseCodeStatus() {
  yield takeEvery('CHANGE_STATUS_RESPONSE_CODE', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.CHANGING_STATUS_RESPONSE_CODE,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield editResponseCodeAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.CHANGE_STATUS_RESPONSE_CODE_SUCCESS,
          loading: false,
          message: result.message
        });

        yield put({
          type: actions.FETCH_RESPONSE_CODE
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.CHANGE_STATUS_RESPONSE_CODE_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.CHANGE_STATUS_RESPONSE_CODE_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.CHANGE_STATUS_RESPONSE_CODE_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* fetchSecurityCode() {
  yield takeEvery('FETCH_SECURITY_CODE', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_SECURITY_CODE,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchSecurityCodeAPI(roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_SECURITY_CODE_SUCCESS,
          loading: false,
          result: result && result.data ? result.data : null
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_SECURITY_CODE_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false,
            result: null
          });
        } else {
          yield put({
            type: actions.FETCH_SECURITY_CODE_FAILED,
            message: 'Failed to process request',
            loading: false,
            result: null
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_SECURITY_CODE_FAILED,
        loading: false,
        message: 'Failed to process request',
        result: null
      });
    }
  });
}
export function* addSecurityCode() {
  yield takeEvery('ADD_SECURITY_CODE', function* ({ payload }) {
    try {
      yield put({
        type: actions.ADDING_SECURITY_CODE,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield addSecurityCodeAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.ADD_SECURITY_CODE_SUCCESS,
          loading: false,
          message: result.message
        });

        yield put({
          type: actions.FETCH_SECURITY_CODE
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.ADD_SECURITY_CODE_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.ADD_SECURITY_CODE_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.ADD_SECURITY_CODE_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* editSecurityCode() {
  yield takeEvery('EDIT_SECURITY_CODE', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.EDITING_SECURITY_CODE,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield editSecurityCodeAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.EDIT_SECURITY_CODE_SUCCESS,
          loading: false,
          message: result.message
        });

        yield put({
          type: actions.FETCH_SECURITY_CODE
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.EDIT_SECURITY_CODE_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.EDIT_SECURITY_CODE_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.EDIT_SECURITY_CODE_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* changeSecurityCodeStatus() {
  yield takeEvery('CHANGE_STATUS_SECURITY_CODE', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.CHANGING_STATUS_SECURITY_CODE,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield editSecurityCodeAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.CHANGE_STATUS_SECURITY_CODE_SUCCESS,
          loading: false,
          message: result.message
        });

        yield put({
          type: actions.FETCH_SECURITY_CODE
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.CHANGE_STATUS_SECURITY_CODE_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.CHANGE_STATUS_SECURITY_CODE_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.CHANGE_STATUS_SECURITY_CODE_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* addBillingDataByMerchantID() {
  yield takeEvery('ADD_BILLING_DATA_BY_MERCHANT_ID', function* ({ payload }) {
    try {
      yield put({
        type: actions.ADDING_BILLING_DATA_BY_MERCHANT_ID,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield addBillingDataByMerchantIDAPI(payload, roleHeaderAuth);
      const state = yield select();
      const billingFilter = state.Transaction.billingFilter;

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.ADD_BILLING_DATA_BY_MERCHANT_ID_SUCCESS,
          loading: false,
          message: result.message
        });
        if (billingFilter) {
          yield put({
            type: actions.FETCH_BILLING_DATA_BY_MERCHANT,
            payload: billingFilter
          });
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.ADD_BILLING_DATA_BY_MERCHANT_ID_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.ADD_BILLING_DATA_BY_MERCHANT_ID_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.ADD_BILLING_DATA_BY_MERCHANT_ID_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* fetchBillingDetails() {
  yield takeEvery('FETCH_BILLING_DETAILS', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_BILLING_DETAILS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchBillingDetailsAPI(payload, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.FETCH_BILLING_DETAILS_SUCCESS,
          loading: false,
          result:
            result && result.data && result.data.billing_details
              ? result.data.billing_details
              : null,
          merchant_fees:
            result && result.data && result.data.merchant_fees ? result.data.merchant_fees : null
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_BILLING_DETAILS_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false,
            result: null
          });
        } else {
          yield put({
            type: actions.FETCH_BILLING_DETAILS_FAILED,
            message: 'Failed to process request',
            loading: false,
            result: null
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_BILLING_DETAILS_FAILED,
        loading: false,
        message: 'Failed to process request',
        result: null
      });
    }
  });
}
export function* fetchBillerDetails() {
  yield takeEvery('FETCH_BILLER_DETAILS', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_BILLER_DETAILS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchBillerDetailsAPI(roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.FETCH_BILLER_DETAILS_SUCCESS,
          loading: false,
          result: result && result.data && result.data ? result.data : null
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_BILLER_DETAILS_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false,
            result: null
          });
        } else {
          yield put({
            type: actions.FETCH_BILLER_DETAILS_FAILED,
            message: 'Failed to process request',
            loading: false,
            result: null
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_BILLER_DETAILS_FAILED,
        loading: false,
        message: 'Failed to process request',
        result: null
      });
    }
  });
}
export function* fetchCollatedData() {
  yield takeEvery('FETCH_COLLATED_DATA_BY_PCHANNEL', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_COLLATED_DATA_BY_PCHANNEL,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchCollatedDataByPChannelAPI(payload, roleHeaderAuth);

      const result = apiResult.data;
      const finalData = result && result.data;
      // ? filterDuplicateTransactionDataWithAmount(result.data, 'request_id')
      // : [];
      // ? filterDuplicateTransactitonData(result.data, 'request_id') : [];

      if (result.success) {
        yield put({
          type: actions.FETCH_COLLATED_DATA_BY_PCHANNEL_SUCCESS,
          loading: false,
          result: finalData,
          filter: payload,
          total: finalData ? finalData.length : 0
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_COLLATED_DATA_BY_PCHANNEL_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false,
            result: null,
            filter: payload
          });
        } else {
          yield put({
            type: actions.FETCH_COLLATED_DATA_BY_PCHANNEL_FAILED,
            message: 'Failed to process request',
            loading: false,
            result: null,
            filter: payload
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_COLLATED_DATA_BY_PCHANNEL_FAILED,
        loading: false,
        message: 'Failed to process request',
        result: null,
        filter: payload
      });
    }
  });
}
export function* analyzeCollateData() {
  yield takeEvery('ANALYZE_COLLATE_DATA_BY_PCHANNEL_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.ANALYZING_COLLATE_DATA_BY_PCHANNEL_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield analyzeCollateDataAPI(payload, roleHeaderAuth);
      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.ANALYZE_COLLATE_DATA_BY_PCHANNEL_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.ANALYZE_COLLATE_DATA_GENERATING_LOADING,
          loading: true
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.ANALYZE_COLLATE_DATA_BY_PCHANNEL_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.ANALYZE_COLLATE_DATA_BY_PCHANNEL_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.ANALYZE_COLLATE_DATA_BY_PCHANNEL_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* generateReportData() {
  yield takeEvery('GENERATE_REPORT_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.GENERATING_REPORT_DATA,
        loading: true
      });
      const state = yield select();
      const settlementReportData = state.Transaction.settlementReportData;
      let data = [];
      if (settlementReportData && settlementReportData.length > 0) {
        settlementReportData.forEach(item => {
          let currObj = {
            ...item
          };
          data.push(currObj);
        });
      }
      let currentObj = {
        file_name: `GENERATE_RECONCILED_TRANSACTION-${moment().format()}.xlsx`,
        created_at: moment().format(),
        id: moment().format(),
        status: 'GENERATING'
      };
      data.unshift(currentObj);
      yield put({
        type: actions.STORE_PENDING_RECONCILED_REPORT_DATA,
        payload: data
      });

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield generateReportDataAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.GENERATE_REPORT_DATA_SUCCESS,
          loading: false,
          message: 'Generating reconciled report. Please wait...'
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.GENERATE_REPORT_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.GENERATE_REPORT_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.GENERATE_REPORT_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* generateMonthReportData() {
  yield takeEvery('GENERATE_MONTH_REPORT_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.GENERATING_MONTH_REPORT_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield generateMonthReportDataAPI(payload, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.GENERATE_MONTH_REPORT_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.GENERATE_MONTH_REPORT_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.GENERATE_MONTH_REPORT_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.GENERATE_MONTH_REPORT_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* downloadMonthlyReconciledReport() {
  yield takeEvery('DOWNLOAD_MONTHLY_RECONCILED_REPORT', function* ({ payload }) {
    try {
      yield put({
        type: actions.DOWNLOADING_MONTHLY_RECONCILED_REPORT,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield downloadMonthlyReconciledReportAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.DOWNLOAD_MONTHLY_RECONCILED_REPORT_SUCCESS,
          loading: false,
          message: 'Monthly reconciled report downloaded successfully.'
        });

        if (result.url) {
          window.location.href = result.url;
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.DOWNLOAD_MONTHLY_RECONCILED_REPORT_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.DOWNLOAD_MONTHLY_RECONCILED_REPORT_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.DOWNLOAD_MONTHLY_RECONCILED_REPORT_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* downloadSettlementReportData() {
  yield takeEvery('DOWNLOAD_SETTLEMENT_REPORT_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.DOWNLOADING_SETTLEMENT_REPORT_DATA,
        loading: true
      });
      const state = yield select();
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield downloadSettlementReportDataAPI(payload, roleHeaderAuth);
      const paymentChannel = state.Tools.uploadedChannel.p_channel;

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.DOWNLOAD_SETTLEMENT_REPORT_DATA_SUCCESS,
          loading: false,
          message: 'Reconciled report downloaded successfully.'
        });

        if (paymentChannel) {
          const logPagination = state.Tools.currentItemLogPagination
            ? state.Tools.currentItemLogPagination
            : { page: 0, limit: 10 };
          yield put({
            type: toolsAction.FETCH_LOGS_BY_ITEM_ID,
            id: paymentChannel,
            payload: {},
            pagination: logPagination
          });
        }

        if (result.url) {
          window.location.href = result.url;
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.DOWNLOAD_SETTLEMENT_REPORT_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.DOWNLOAD_SETTLEMENT_REPORT_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }

        if (paymentChannel) {
          const logPagination = state.Tools.currentItemLogPagination
            ? state.Tools.currentItemLogPagination
            : { page: 0, limit: 10 };
          yield put({
            type: toolsAction.FETCH_LOGS_BY_ITEM_ID,
            id: paymentChannel,
            payload: {},
            pagination: logPagination
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.DOWNLOAD_SETTLEMENT_REPORT_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* generateUnreconciledReportData() {
  yield takeEvery('GENERATE_UNRECONCILED_REPORT_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.GENERATING_UNRECONCILED_REPORT_DATA,
        loading: true
      });

      yield put({
        type: mqttActions.CONNECT_MQTT,
        payload: payload
      });

      const event = yield take([mqttActions.CONNECT_SUCCESS]);

      if (event.type !== mqttActions.CONNECT_SUCCESS) {
        yield put({
          type: actions.GENERATE_UNRECONCILED_REPORT_DATA_FAILED,
          message: 'Failed to process request',
          loading: false
        });
      }

      const state = yield select();
      const unreconciledReportData = state.Transaction.unreconciledReportData;
      let data = [];
      if (unreconciledReportData && unreconciledReportData.length > 0) {
        unreconciledReportData.forEach(item => {
          let currObj = {
            ...item
          };
          data.push(currObj);
        });
      }
      let currentObj = {
        file_name: `GENERATE_UNSETTLED_TRANSACTION-${moment().format()}.xlsx`,
        created_at: moment().format(),
        id: moment().format(),
        status: 'GENERATING'
      };
      data.unshift(currentObj);
      yield put({
        type: actions.STORE_PENDING_UNRECONCILED_REPORT_DATA,
        payload: data
      });

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield generateUnreconciledReportDataAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.GENERATE_UNRECONCILED_REPORT_DATA_SUCCESS,
          loading: false,
          message: 'Generating unreconciled report. Please wait...'
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.GENERATE_UNRECONCILED_REPORT_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.GENERATE_UNRECONCILED_REPORT_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.GENERATE_UNRECONCILED_REPORT_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* downloadUnreconciledReportData() {
  yield takeEvery('DOWNLOAD_UNRECONCILED_REPORT_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.DOWNLOADING_UNRECONCILED_REPORT_DATA,
        loading: true
      });
      const state = yield select();
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield downloadUnreconciledReportDataAPI(payload, roleHeaderAuth);
      const paymentChannel = state.Tools.uploadedChannel.p_channel;

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.DOWNLOAD_UNRECONCILED_REPORT_DATA_SUCCESS,
          loading: false,
          message: 'Unreconciled report downloaded successfully.'
        });

        if (paymentChannel) {
          const logPagination = state.Tools.currentItemLogPagination
            ? state.Tools.currentItemLogPagination
            : { page: 0, limit: 10 };
          yield put({
            type: toolsAction.FETCH_LOGS_BY_ITEM_ID,
            id: paymentChannel,
            payload: {},
            pagination: logPagination
          });
        }

        if (result.url) {
          window.location.href = result.url;
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.DOWNLOAD_UNRECONCILED_REPORT_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.DOWNLOAD_UNRECONCILED_REPORT_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }

        if (paymentChannel) {
          const logPagination = state.Tools.currentItemLogPagination
            ? state.Tools.currentItemLogPagination
            : { page: 0, limit: 10 };
          yield put({
            type: toolsAction.FETCH_LOGS_BY_ITEM_ID,
            id: paymentChannel,
            payload: {},
            pagination: logPagination
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.DOWNLOAD_UNRECONCILED_REPORT_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* checkCollateDataFromDev() {
  yield takeEvery('CHECK_COLLATE_DATA_BY_PCHANNEL_DATA_FROM_DEV', function* ({ payload }) {
    try {
      yield put({
        type: actions.CHECKING_COLLATE_DATA_BY_PCHANNEL_DATA_FROM_DEV,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield checkCollateDataFromDevAPI(payload, roleHeaderAuth);
      const state = yield select();
      const collatedDataFilter = state.Transaction.collatedDataFilter;
      const reconciliationFilter = state.Transaction.reconciliationFilter;

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.CHECK_COLLATE_DATA_BY_PCHANNEL_DATA_FROM_DEV_SUCCESS,
          loading: false,
          message: result.message
        });
        if (reconciliationFilter) {
          yield put({
            type: actions.FETCH_RECONCILIATION_DATA_BY_PCHANNEL,
            payload: {
              ...reconciliationFilter,
              pagination: {
                page: 0,
                limit: 20
              }
            }
          });
        }
        if (collatedDataFilter) {
          yield put({
            type: actions.FETCH_COLLATED_DATA_BY_PCHANNEL,
            payload: {
              ...collatedDataFilter,
              pagination: {
                page: 0,
                limit: 20
              }
            }
          });
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.CHECK_COLLATE_DATA_BY_PCHANNEL_DATA_FROM_DEV_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.CHECK_COLLATE_DATA_BY_PCHANNEL_DATA_FROM_DEV_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.CHECK_COLLATE_DATA_BY_PCHANNEL_DATA_FROM_DEV_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* checkCollateDataFromPaygate() {
  yield takeEvery('CHECK_COLLATE_DATA_BY_PCHANNEL_DATA_FROM_PAYGATE', function* ({ payload }) {
    try {
      yield put({
        type: actions.CHECKING_COLLATE_DATA_BY_PCHANNEL_DATA_FROM_PAYGATE,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield checkCollateDataFromPaygateAPI(payload, roleHeaderAuth);
      const state = yield select();
      const collatedDataFilter = state.Transaction.collatedDataFilter;
      const reconciliationFilter = state.Transaction.reconciliationFilter;

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.CHECK_COLLATE_DATA_BY_PCHANNEL_DATA_FROM_PAYGATE_SUCCESS,
          loading: false,
          message: result.message
        });
        if (reconciliationFilter) {
          yield put({
            type: actions.FETCH_RECONCILIATION_DATA_BY_PCHANNEL,
            payload: {
              ...reconciliationFilter,
              pagination: {
                page: 0,
                limit: 20
              }
            }
          });
        }
        if (collatedDataFilter) {
          yield put({
            type: actions.FETCH_COLLATED_DATA_BY_PCHANNEL,
            payload: {
              ...collatedDataFilter,
              pagination: {
                page: 0,
                limit: 20
              }
            }
          });
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.CHECK_COLLATE_DATA_BY_PCHANNEL_DATA_FROM_PAYGATE_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.CHECK_COLLATE_DATA_BY_PCHANNEL_DATA_FROM_PAYGATE_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.CHECK_COLLATE_DATA_BY_PCHANNEL_DATA_FROM_PAYGATE_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* fetchCaseDetails() {
  yield takeEvery('FETCH_CASE_DETAILS_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_CASE_DETAILS_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchCaseDetailsAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_CASE_DETAILS_DATA_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
      } else {
        yield put({
          type: actions.FETCH_CASE_DETAILS_DATA_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_CASE_DETAILS_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* updateCaseDetails() {
  yield takeEvery('UPDATE_CASE_DETAILS', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.UPDATING_CASE_DETAILS,
        loading: true
      });

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield updateCaseDetailsAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.UPDATE_CASE_DETAILS_SUCCESS,
          loading: false,
          message: result.message
        });
        if (id && payload && payload.data && payload.data.length > 0) {
          yield put({
            type: actions.SETUP_CASE_DETAIL,
            result: payload.data
          });
        }

        yield put({
          type: actions.FETCH_CASE_DETAILS_DATA,
          payload: id
        });
        if (payload && payload.id) {
          yield put({
            type: actions.FETCH_CASE_LOGS,
            payload: payload.id,
            pagination: {
              page: 0,
              limit: 10
            }
          });
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.UPDATE_CASE_DETAILS_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.UPDATE_CASE_DETAILS_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.UPDATE_CASE_DETAILS_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* inviteCaseMember() {
  yield takeEvery('INVITE_CASE_MEMBER', function* ({ payload }) {
    try {
      yield put({
        type: actions.INVITING_CASE_MEMBER,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield inviteCaseMemberAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.INVITE_CASE_MEMBER_SUCCESS,
          loading: false,
          message: result.message
        });
        if (payload && payload.case_id_str) {
          yield put({
            type: actions.FETCH_CASE_DETAILS_DATA,
            payload: payload.case_id_str
          });
        }
        if (payload && payload.case_id) {
          yield put({
            type: actions.FETCH_CASE_LOGS,
            payload: payload.case_id,
            pagination: {
              page: 0,
              limit: 10
            }
          });
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.INVITE_CASE_MEMBER_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.INVITE_CASE_MEMBER_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.INVITE_CASE_MEMBER_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* fetchSettlementReportData() {
  yield takeEvery('FETCH_SETTLEMENT_REPORT', function* ({ payload, pagination }) {
    try {
      const loadmore = pagination.loadMore;
      if (loadmore) {
        yield put({
          type: actions.LOAD_MORE_SETTLEMENT_REPORT
        });
      } else {
        yield put({
          type: actions.FETCHING_SETTLEMENT_REPORT,
          loading: true
        });
      }
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchSettlementReportDataAPI(
        payload,
        {
          page: pagination.page,
          limit: pagination.limit
        },
        roleHeaderAuth
      );
      // const currentList = pagination.currentList && loadmore ? pagination.currentList : [];
      const result = apiResult.data;
      // const parseData =
      //   currentList && currentList.length > 0 ? currentList.concat(result.data) : result.data;

      // const finalData = filterDuplicateData(parseData);

      if (result.success) {
        yield put({
          type: actions.FETCH_SETTLEMENT_REPORT_SUCCESS,
          loading: false,
          result: result && result.data ? result.data : [],
          filter: payload,
          pagination: pagination
            ? {
                ...pagination,
                total: result && result.total_doc ? result.total_doc : 20
              }
            : null,
          message: `Reports successfully fetched`
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_SETTLEMENT_REPORT_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false,
            result: []
          });
        } else {
          yield put({
            type: actions.FETCH_SETTLEMENT_REPORT_FAILED,
            message: 'Failed to process request',
            loading: false,
            result: []
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_SETTLEMENT_REPORT_FAILED,
        loading: false,
        message: 'Failed to process request',
        result: []
      });
    }
  });
}

export function* fetchAllMonthSettlementReportData() {
  yield takeEvery('FETCH_MONTH_SETTLEMENT_REPORT', function* ({ payload, pagination }) {
    try {
      const loadmore = pagination.loadMore;
      if (loadmore) {
        yield put({
          type: actions.LOAD_MORE_MONTH_SETTLEMENT_REPORT
        });
      } else {
        yield put({
          type: actions.FETCHING_MONTH_SETTLEMENT_REPORT,
          loading: true
        });
      }
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchAllMonthReconciledReportDataAPI(
        payload,
        {
          page: pagination.page,
          limit: pagination.limit
        },
        roleHeaderAuth
      );
      // const currentList = pagination.currentList && loadmore ? pagination.currentList : [];
      const result = apiResult.data;
      // const parseData =
      //   currentList && currentList.length > 0 ? currentList.concat(result.data) : result.data;
      // const finalData = filterDuplicateData(parseData);
      if (result.success) {
        yield put({
          type: actions.FETCH_MONTH_SETTLEMENT_REPORT_SUCCESS,
          loading: false,
          result: result && result.data ? result.data : [],
          filter: payload,
          pagination: pagination
            ? {
                ...pagination,
                total: result && result.total_doc ? result.total_doc : 0
              }
            : null,
          message: `Reports successfully fetched`
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_MONTH_SETTLEMENT_REPORT_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false,
            result: []
          });
        } else {
          yield put({
            type: actions.FETCH_MONTH_SETTLEMENT_REPORT_FAILED,
            message: 'Failed to process request',
            loading: false,
            result: []
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_MONTH_SETTLEMENT_REPORT_FAILED,
        loading: false,
        message: 'Failed to process request',
        result: []
      });
    }
  });
}

export function* fetchUnreconciledReportData() {
  yield takeEvery('FETCH_UNRECONCILED_REPORT_LIST', function* ({ payload, pagination }) {
    try {

      if (!payload?.payment_channel || payload?.payment_channel === "") {
        return;
      }

      const loadmore = pagination.loadMore;
      if (loadmore) {
        yield put({
          type: actions.LOAD_MORE_UNRECONCILED_REPORT_LIST
        });
      } else {
        yield put({
          type: actions.FETCHING_UNRECONCILED_REPORT_LIST,
          loading: true
        });
      }
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchUnreconciledReportDataAPI(
        payload,
        {
          page: pagination.page,
          limit: pagination.limit
        },
        roleHeaderAuth
      );
      // const currentList = pagination.currentList && loadmore ? pagination.currentList : [];
      const result = apiResult.data;
      // const parseData =
      //   currentList && currentList.length > 0 ? currentList.concat(result.data) : result.data;

      // const finalData = filterDuplicateData(parseData);

      if (result.success) {
        yield put({
          type: actions.FETCH_UNRECONCILED_REPORT_LIST_SUCCESS,
          loading: false,
          result: result && result.data ? result.data : [],
          filter: payload,
          pagination: pagination
            ? {
                ...pagination,
                total: result && result.total_doc ? result.total_doc : 20
              }
            : null,
          message: `Reports successfully fetched`
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_UNRECONCILED_REPORT_LIST_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false,
            result: []
          });
        } else {
          yield put({
            type: actions.FETCH_UNRECONCILED_REPORT_LIST_FAILED,
            message: 'Failed to process request',
            loading: false,
            result: []
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_UNRECONCILED_REPORT_LIST_FAILED,
        loading: false,
        message: 'Failed to process request',
        result: []
      });
    }
  });
}
export function* fetchFinanceDashboardData() {
  yield takeEvery('FETCH_FINANCE_DASHBOARD_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_FINANCE_DASHBOARD_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchFinanceDashboardDataAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_FINANCE_DASHBOARD_DATA_SUCCESS,
          loading: false,
          result: result.data,
          pagination: result.pagination,
          filter: payload
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_FINANCE_DASHBOARD_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false,
            result: null,
            filter: payload
          });
        } else {
          yield put({
            type: actions.FETCH_FINANCE_DASHBOARD_DATA_FAILED,
            message: 'Failed to process request',
            loading: false,
            result: null,
            filter: payload
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_FINANCE_DASHBOARD_DATA_FAILED,
        loading: false,
        message: 'Failed to process request',
        result: null,
        filter: payload
      });
    }
  });
}
export function* checkCollateData() {
  yield takeEvery('CHECK_COLLATE_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.CHECKING_COLLATE_DATA,
        loading: true
      });

      yield put({
        type: mqttActions.CONNECT_MQTT,
        payload: payload
      });

      const event = yield take([mqttActions.CONNECT_SUCCESS]);

      if (event.type !== mqttActions.CONNECT_SUCCESS) {
        yield put({
          type: actions.CHECK_COLLATE_DATA_FAILED,
          message: 'Failed to process request',
          loading: false
        });
      }

      const state = yield select();
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield checkCollateDataAPI(payload, roleHeaderAuth);
      const paymentChannel = state.Tools.uploadedChannel.p_channel;

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.CHECK_COLLATE_DATA_SUCCESS,
          loading: false,
          message: result.message
        });

        yield put({
          type: actions.CHECK_COLLATE_DATA_MQTT_LOADING,
          loading: true
        });

        if (paymentChannel) {
          const logPagination = state.Tools.currentItemLogPagination
            ? state.Tools.currentItemLogPagination
            : { page: 0, limit: 10 };
          yield put({
            type: toolsAction.FETCH_LOGS_BY_ITEM_ID,
            id: paymentChannel,
            payload: {},
            pagination: logPagination
          });
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.CHECK_COLLATE_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.CHECK_COLLATE_DATA_FAILED,
            message: result && result.message ? result.message : 'No transaction found.',
            loading: false
          });

          if (paymentChannel) {
            const logPagination = state.Tools.currentItemLogPagination
              ? state.Tools.currentItemLogPagination
              : { page: 0, limit: 10 };
            yield put({
              type: toolsAction.FETCH_LOGS_BY_ITEM_ID,
              id: paymentChannel,
              payload: {},
              pagination: logPagination
            });
          }
        }

        if (paymentChannel) {
          const logPagination = state.Tools.currentItemLogPagination
            ? state.Tools.currentItemLogPagination
            : { page: 0, limit: 10 };
          yield put({
            type: toolsAction.FETCH_LOGS_BY_ITEM_ID,
            id: paymentChannel,
            payload: {},
            pagination: logPagination
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.CHECK_COLLATE_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* fetchAllReconciledData() {
  yield takeEvery('FETCH_ALL_RECONCILED_DATA', function* ({ payload, pagination }) {
    try {
      yield put({
        type: actions.FETCHING_ALL_RECONCILED_DATA,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchAllReconciledDataAPI(payload, pagination, roleHeaderAuth);

      const result = apiResult.data;

      const finalData = result && result.data;
      // ? filterDuplicateTransactionDataWithAmount(result.data, 'request_id')
      // : [];
      // ? filterDuplicateTransactitonData(result.data, 'request_id') : [];

      if (result.success) {
        yield put({
          type: actions.FETCH_ALL_RECONCILED_DATA_SUCCESS,
          loading: false,
          result: finalData || result.data,
          pagination: result.pagination,
          filter: payload
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_ALL_RECONCILED_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false,
            result: null,
            filter: payload
          });
        } else {
          yield put({
            type: actions.FETCH_ALL_RECONCILED_DATA_FAILED,
            message: 'Failed to process request',
            loading: false,
            result: null,
            filter: payload
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_ALL_RECONCILED_DATA_FAILED,
        loading: false,
        message: 'Failed to process request',
        result: null,
        filter: payload
      });
    }
  });
}
export function* escalateTransactionData() {
  yield takeEvery('ESCALATE_TRANSACTION_DATA', function* ({ payload }) {
    try {
      yield put({
        type: actions.ESCALATING_TRANSACTION_DATA,
        loading: true
      });

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield escalateTransactionDataAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.ESCALATE_TRANSACTION_DATA_SUCCESS,
          loading: false,
          message: result.message
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.ESCALATE_TRANSACTION_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.ESCALATE_TRANSACTION_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.ESCALATE_TRANSACTION_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* fetchAllCases() {
  yield takeEvery('FETCH_CASE_TRANSACTION_DATA', function* ({ payload, currentList }) {
    try {
      if (payload && payload.loadMore) {
        yield put({
          type: actions.LOAD_MORE_CASE_TRANSACTIONS,
          loading: true
        });
      } else {
        yield put({
          type: actions.FETCHING_CASE_TRANSACTION_DATA,
          loading: true
        });
      }

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchAllCasesAPI(payload, roleHeaderAuth);
      const result = apiResult.data;

      const listData = currentList && payload.loadMore && currentList.length > 0 ? currentList : [];
      const parseData =
        listData && listData.length > 0 ? listData.concat(result.data) : result.data;
      const finalData = filterDuplicateData(parseData);

      if (result.success) {
        yield put({
          type: actions.FETCH_CASE_TRANSACTION_DATA_SUCCESS,
          loading: false,
          result: finalData,
          pagination: result.pagination,
          filter: {
            ...payload
          }
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_CASE_TRANSACTION_DATA_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.FETCH_CASE_TRANSACTION_DATA_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_CASE_TRANSACTION_DATA_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* fetchUploadedBankFiles() {
  yield takeEvery('FETCH_UPLOADED_BANK_FILES', function* ({ payload, pagination }) {
    try {
      yield put({
        type: actions.FETCHING_UPLOADED_BANK_FILES,
        loading: true,
        activeBank: payload.bank_id
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchUploadedBankFileApi(payload, pagination, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_UPLOADED_BANK_FILES_SUCCESS,
          loading: false,
          result: result ? result.data : [],
          pagination: result && result.pagination ? result.pagination : null,
          activeBank: payload.bank_id
        });

        if (payload && payload.bank_id) {
          const state = yield select();
          const pagination = state.Tools.currentItemLogPagination
            ? state.Tools.currentItemLogPagination
            : { page: 0, limit: 10 };
          yield put({
            type: toolsAction.FETCH_LOGS_BY_ITEM_ID,
            id: payload.bank_id,
            payload: {},
            pagination
          });
        }
      } else {
        yield put({
          type: actions.FETCH_UPLOADED_BANK_FILES_FAILED,
          loading: false,
          activeBank: payload.bank_id
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_UPLOADED_BANK_FILES_FAILED,
        loading: false,
        activeBank: payload.bank_id
      });
    }
  });
}

export function* fetchUploadedBankTransaction() {
  yield takeEvery('FETCH_UPLOADED_BANK_TRANSACTION', function* ({ id, payload, pagination }) {
    try {
      yield put({
        type: actions.FETCHING_UPLOADED_BANK_TRANSACTION,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchUploadedBankTransactionApi(
        id,
        payload,
        pagination,
        roleHeaderAuth
      );

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_UPLOADED_BANK_TRANSACTION_SUCCESS,
          loading: false,
          result: result ? result.data : [],
          pagination: result ? result.pagination : null,
          activeBank: id,
          bankTransactionFilter: payload
        });
      } else {
        yield put({
          type: actions.FETCH_UPLOADED_BANK_TRANSACTION_FAILED,
          loading: false,
          bankTransactionFilter: payload
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_UPLOADED_BANK_TRANSACTION_FAILED,
        loading: false,
        bankTransactionFilter: payload
      });
    }
  });
}

export function* updateBankRemittance() {
  yield takeEvery('UPDATE_BANK_REMITTANCE', function* ({ payload }) {
    try {
      yield put({
        type: actions.UPDATING_BANK_REMITTANCE,
        loading: true
      });

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield updateBankRemittanceAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      const state = yield select();
      const bankTrxFilter = state.Transaction.bankTransactionFilter;
      const trxPagination = state.Transaction.uploadedBankTransactionPagination;

      if (result.success) {
        yield put({
          type: actions.UPDATE_BANK_REMITTANCE_SUCCESS,
          loading: false,
          message: result.message
        });

        if (bankTrxFilter && trxPagination && payload.current_bank_id) {
          yield put({
            type: actions.FETCH_UPLOADED_BANK_TRANSACTION,
            id: payload.current_bank_id,
            payload: {
              date_filter:
                bankTrxFilter && bankTrxFilter.date_filter
                  ? bankTrxFilter.date_filter
                  : 'transaction',
              date:
                bankTrxFilter &&
                bankTrxFilter.date &&
                bankTrxFilter.date.from &&
                bankTrxFilter.date.to
                  ? bankTrxFilter.date
                  : null,
              payment_channel:
                bankTrxFilter && bankTrxFilter.payment_channel ? bankTrxFilter.payment_channel : ''
            },
            pagination: trxPagination
          });
        }

        if (payload && payload.current_bank_id) {
          const logPagination = state.Tools.currentItemLogPagination
            ? state.Tools.currentItemLogPagination
            : { page: 0, limit: 10 };

          yield put({
            type: toolsAction.FETCH_LOGS_BY_ITEM_ID,
            id: payload.current_bank_id,
            payload: {},
            pagination: logPagination
          });
        }
      } else {
        yield put({
          type: actions.UPDATE_BANK_REMITTANCE_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.UPDATE_BANK_REMITTANCE_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* updateBankTransaction() {
  yield takeEvery('UPDATE_BANK_TRANSACTION', function* ({ payload }) {
    try {
      yield put({
        type: actions.UPDATING_BANK_TRANSACTION,
        loading: true
      });

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield updateBankTransactionAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      const state = yield select();
      const bankTrxFilter = state.Transaction.bankTransactionFilter;
      const trxPagination = state.Transaction.uploadedBankTransactionPagination;

      if (result.success) {
        yield put({
          type: actions.UPDATE_BANK_TRANSACTION_SUCCESS,
          loading: false,
          message: result.message
        });

        if (bankTrxFilter && trxPagination && payload.current_bank_id) {
          yield put({
            type: actions.FETCH_UPLOADED_BANK_TRANSACTION,
            id: payload.current_bank_id,
            payload: {
              date_filter:
                bankTrxFilter && bankTrxFilter.date_filter
                  ? bankTrxFilter.date_filter
                  : 'transaction',
              date:
                bankTrxFilter &&
                bankTrxFilter.date &&
                bankTrxFilter.date.from &&
                bankTrxFilter.date.to
                  ? bankTrxFilter.date
                  : null,
              payment_channel:
                bankTrxFilter && bankTrxFilter.payment_channel ? bankTrxFilter.payment_channel : ''
            },
            pagination: trxPagination
          });
        }

        if (payload && payload.current_bank_id) {
          const logPagination = state.Tools.currentItemLogPagination
            ? state.Tools.currentItemLogPagination
            : { page: 0, limit: 10 };

          yield put({
            type: toolsAction.FETCH_LOGS_BY_ITEM_ID,
            id: payload.current_bank_id,
            payload: {},
            pagination: logPagination
          });
        }
      } else {
        yield put({
          type: actions.UPDATE_BANK_TRANSACTION_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.UPDATE_BANK_TRANSACTION_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* updateBankFile() {
  yield takeEvery('UPDATE_BANK_FILE', function* ({ id, payload }) {
    try {
      yield put({
        type: actions.UPDATING_BANK_FILE,
        loading: true
      });

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield updateBankFileAPI(id, payload, roleHeaderAuth);

      const result = apiResult.data;

      const state = yield select();
      const filePagination = state.Transaction.uploadedBankFilesPagination;
      const activeBank = state.Transaction.activeUploadedBank;

      if (result.success) {
        yield put({
          type: actions.UPDATE_BANK_FILE_SUCCESS,
          loading: false,
          message: result.message
        });

        if (activeBank && filePagination) {
          yield put({
            type: actions.FETCH_UPLOADED_BANK_FILES,
            payload: { bank_id: activeBank },
            pagination: filePagination
          });
          const logPagination = state.Tools.currentItemLogPagination
            ? state.Tools.currentItemLogPagination
            : { page: 0, limit: 10 };

          yield put({
            type: toolsAction.FETCH_LOGS_BY_ITEM_ID,
            id: activeBank,
            payload: {},
            pagination: logPagination
          });
        }
      } else {
        yield put({
          type: actions.UPDATE_BANK_FILE_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.UPDATE_BANK_FILE_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* generateBankTrxStatistics() {
  yield takeEvery('GENERATE_BANK_TRANSACTION_STATISTICS', function* ({ id, payload }) {
    try {
      yield put({
        type: actions.GENERATING_BANK_TRANSACTION_STATISTICS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield generateBankTrxStatisticsAPI(id, payload, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.GENERATE_BANK_TRANSACTION_STATISTICS_SUCCESS,
          loading: false,
          result: result ? result.data : [],
          activeBank: id,
          bankTransactionFilter: payload
        });
      } else {
        yield put({
          type: actions.GENERATE_BANK_TRANSACTION_STATISTICS_FAILED,
          loading: false,
          bankTransactionFilter: payload
        });
      }
    } catch (error) {
      yield put({
        type: actions.GENERATE_BANK_TRANSACTION_STATISTICS_FAILED,
        loading: false,
        bankTransactionFilter: payload
      });
    }
  });
}

export function* fetchAllChannelSchedule() {
  yield takeEvery('FETCH_ALL_REMITTING_CHANNEL_SCHEDULE', function* () {
    try {
      yield put({
        type: actions.FETCHING_ALL_REMITTING_CHANNEL_SCHEDULE,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchAllChannelScheduleAPI(roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.FETCH_ALL_REMITTING_CHANNEL_SCHEDULE_SUCCESS,
          loading: false,
          result: result.data
        });
      } else {
        yield put({
          type: actions.FETCH_ALL_REMITTING_CHANNEL_SCHEDULE_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_ALL_REMITTING_CHANNEL_SCHEDULE_FAILED,
        loading: false
      });
    }
  });
}

export function* addChannelSchedule() {
  yield takeEvery('ADD_REMITTING_CHANNEL_SCHEDULE', function* ({ payload }) {
    try {
      yield put({
        type: actions.ADDING_REMITTING_CHANNEL_SCHEDULE,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield addChannelScheduleAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.ADD_REMITTING_CHANNEL_SCHEDULE_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_ALL_REMITTING_CHANNEL_SCHEDULE
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.ADD_REMITTING_CHANNEL_SCHEDULE_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.ADD_REMITTING_CHANNEL_SCHEDULE_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.ADD_REMITTING_CHANNEL_SCHEDULE_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* updateChannelSchedule() {
  yield takeEvery('EDIT_REMITTING_CHANNEL_SCHEDULE', function* ({ id, payload }) {
    try {
      yield put({
        type: actions.EDITING_REMITTING_CHANNEL_SCHEDULE,
        loading: true
      });

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield editChannelScheduleAPI(id, payload, roleHeaderAuth);

      const result = apiResult.data;
      // const activeBank = state.Transaction.activeUploadedBank;

      if (result.success) {
        yield put({
          type: actions.EDIT_REMITTING_CHANNEL_SCHEDULE_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_ALL_REMITTING_CHANNEL_SCHEDULE
        });
      } else {
        yield put({
          type: actions.EDIT_REMITTING_CHANNEL_SCHEDULE_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.EDIT_REMITTING_CHANNEL_SCHEDULE_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* deleteBankFileAndTransactions() {
  yield takeEvery('DELETE_UPLOADED_BANK_FILE_AND_TRANSACTIONS', function* ({ id }) {
    try {
      yield put({
        type: actions.DELETING_UPLOADED_BANK_FILE_AND_TRANSACTIONS,
        loading: true
      });

      const state = yield select();
      const filePagination = state.Transaction.uploadedBankFilesPagination;
      const activeBank = state.Transaction.activeUploadedBank;

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield deleteBankFileAndTransactionsAPI(id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.DELETE_UPLOADED_BANK_FILE_AND_TRANSACTIONS_SUCCESS,
          loading: false,
          message: result.message
        });
        if (activeBank && filePagination) {
          yield put({
            type: actions.FETCH_UPLOADED_BANK_FILES,
            payload: { bank_id: activeBank },
            pagination: filePagination
          });
          const logPagination = state.Tools.currentItemLogPagination
            ? state.Tools.currentItemLogPagination
            : { page: 0, limit: 10 };

          yield put({
            type: toolsAction.FETCH_LOGS_BY_ITEM_ID,
            id: activeBank,
            payload: {},
            pagination: logPagination
          });
        }
      } else {
        yield put({
          type: actions.DELETE_UPLOADED_BANK_FILE_AND_TRANSACTIONS_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.DELETE_UPLOADED_BANK_FILE_AND_TRANSACTIONS_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* getTrxList() {
  yield takeEvery('FETCH_TRANSACTION_LIST', function* (payload) {
    try {
      if (payload.payload.reset_list === true) {
        yield put({
          type: actions.FETCH_TRANSACTION_LIST_RESET
        });
      }
      yield put({
        type: actions.FETCHING_TRANSACTION_LIST,
        reset: payload.payload.reset_list
      });
      console.log("payload: ", payload)
      const apiResult = yield fetchTrxList(payload.payload);
      const result = apiResult.data;
      if (result.success === true) {
        // trxCollection = {
        //   ...trxCollection,
        //   [payload.payload.currentPage]: result
        // };
        yield put({
          type: actions.FETCHED_TRANSACTION_LIST_FINAL,
          payload: result.data,
          collection: payload,
          count: result.total && result.total !== undefined ? result.total : '',
          page: payload.currentPage
        });
      } else {
        yield put({
          type: actions.FETCH_TRANSACTION_LIST_FAILED,
          message: result.message
        });
      }
      // }
    } catch (error) {
      yield put({
        type: actions.FETCH_TRANSACTION_LIST_FAILED,
        payload: error
      });
    }
  });
}

export function* getTrxDetails() {
  yield takeEvery('FETCH_TRANSACTION_DETAILS', function* (payload) {
    try {
      yield put({
        type: actions.FETCHING_TRANSACTION_DETAILS
      });
      const apiResult = yield fetchTrxDetails(payload.payload);
      if (apiResult.status === 200) {
        yield put({
          type: actions.FETCHED_TRANSACTION_DETAILS,
          payload: apiResult.data.data[0],
        });
      } else {
        yield put({
          type: actions.FETCH_TRANSACTION_DETAILS_FAILED,
          error: apiResult.message
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_TRANSACTION_DETAILS_FAILED,
        payload: error
      });
    }
  });
}

export function* fetchOtcTransactions() {
  yield takeEvery('FETCH_OTC_TRANSACTIONS', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_OTC_TRANSACTIONS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchOtcTransactionsAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_OTC_TRANSACTIONS_SUCCESS,
          loading: false,
          result: result.data,
          filter: payload
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_OTC_TRANSACTIONS_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false,
            result: null,
            filter: payload
          });
        } else {
          yield put({
            type: actions.FETCH_OTC_TRANSACTIONS_FAILED,
            message: result.message ? result.message : 'Failed to process request',
            loading: false,
            result: null,
            filter: payload
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_OTC_TRANSACTIONS_FAILED,
        loading: false,
        message: 'Failed to process request',
        result: null,
        filter: payload
      });
    }
  });
}

export function* updateOtcTransactions() {
  yield takeEvery('UPDATE_OTC_TRANSACTIONS', function* ({ payload }) {
    try {
      yield put({
        type: actions.UPDATING_OTC_TRANSACTIONS,
        loading: true
      });

      const otcId = payload.otc_id;
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield updateOtcTransactionsAPI(payload, roleHeaderAuth);
      const state = yield select();
      const otcTransactionsFilter = state.Transaction.otcTransactionsFilter;

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.UPDATE_OTC_TRANSACTIONS_SUCCESS,
          loading: false,
          message: result.message
        });

        if (otcTransactionsFilter) {
          yield put({
            type: actions.FETCH_OTC_TRANSACTIONS,
            payload: {
              ...otcTransactionsFilter
            }
          });
        }

        const logPagination = state.Tools.currentItemLogPagination
          ? state.Tools.currentItemLogPagination
          : { page: 0, limit: 10 };
        yield put({
          type: toolsAction.FETCH_LOGS_BY_ITEM_ID,
          id: otcId,
          payload: {},
          pagination: logPagination
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.UPDATE_OTC_TRANSACTIONS_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.UPDATE_OTC_TRANSACTIONS_FAILED,
            message: result.message ? result.message : 'Failed to process request',
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.UPDATE_OTC_TRANSACTIONS_FAILED,
        loading: false,
        message: 'Failed to process request'
      });
    }
  });
}

export function* downloadCsv() {
  yield takeEvery('DOWNLOAD_CSV', function* (payload) {
    try {
      yield put({
        type: actions.DOWNLOADING_CSV
      });
      // const state = yield select();
      const apiResult = yield getDownloadCSV(payload.payload);
      const result = apiResult.data;
      // // customLogs('RESULLTTTT', result);
      if (result.success) {
        yield put({
          type: actions.DOWNLOADED_CSV,
          payload: result.data
        });
        // const currentData = state.Transactions.excelDownloadList;
        // const newList = `_`.union([result.data], currentData);
        // // customLogs('CURRENT_DATA', currentData);
        yield put({
          type: actions.FETCH_EXCEL_DOWNLOAD_LIST,
          payload: {
            module: payload.payload.module
          }
        });
      } else {
        yield put ({
          type: actions.DOWNLOD_FAILED_CSV
        })
      }
      // customLogs('DOWNLOADED_CSV_RESULT: ', result);
    } catch (error) {
      yield put({
        type: actions.DOWNLOD_FAILED_CSV,
        payload: error
      });
    }
  });
}

export function* getPreviousDownloads() {
  yield takeEvery('FETCH_PREVIOUS_DOWNLOADS', function* (payload) {
    try {
      yield put({
        type: actions.FETCHING_PREVIOUS_DOWNLOADS
      });
      const apiResult = yield fetchPrevDownloads(payload.payload);
      const result = apiResult.data.data;
      if (apiResult.data.success) {
        yield put({
          type: actions.FETCHED_PREVIOUS_DOWNLOADS,
          payload: result
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_PREVIOUS_DOWNLOADS_FAILED,
        payload: error
      });
    }
  });
}

export function* getExcelDownloadList() {
  yield takeEvery('FETCH_EXCEL_DOWNLOAD_LIST', function* (payload) {
    try {
      yield put({
        type: actions.FETCHING_EXCEL_DOWNLOAD_LIST
      });
      const apiResult = yield fetchExcelList(payload.payload);
      const result = apiResult.data.data;
      if (apiResult.data.success) {
        yield put({
          type: actions.FETCHED_EXCEL_DOWNLOAD_LIST,
          payload: result
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_EXCEL_DOWNLOAD_LIST_FAILED,
        payload: error
      });
    }
  });
}

export function* getTrxMerchants() {
  yield takeEvery('FETCH_MERCHANTS', function* () {
    try {
      yield put({
        type: actions.FETCHING_MERCHANTS
      });
      const apiResult = yield fetchMerchants();
      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.FETCHED_MERCHANTS,
          payload: result.data
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_MERCHANTS_FAILED,
        payload: error
      });
    }
  });
}

export function* fetchDownloadReport() {
  yield takeEvery('FETCH_DOWNLOAD_REPORT', function* (payload) {
    try {
      yield put({
        type: actions.FETCHING_DOWNLOAD_REPORT
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield getDownloadReport(payload.payload, roleHeaderAuth);
      const result = apiResult.data.data;

      if (apiResult.data.success) {
        yield put({
          type: actions.FETCHED_DOWNLOAD_REPORT,
          loading: false,
          message: apiResult.data.message
        });
        if (result.url) {
          // window.open(result.url, '_blank');
          window.location.href = result.url;
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_DOWNLOAD_REPORT_FAILED,
            message: `Something went wrong`,
            loading: false
          });
        } else {
          yield put({
            type: actions.FETCH_DOWNLOAD_REPORT_FAILED,
            message: 'Something went wrong',
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_DOWNLOAD_REPORT_FAILED
      });
    }
  });
}

export function* fetchAllFinanceOperations() {
  yield takeEvery('FETCH_ALL_FINANCE_OPERATIONS', function* ({ payload, currentList }) {
    try {
      if (payload && payload.loadMore) {
        yield put({
          type: actions.LOADING_MORE_FINANCE_OPERATIONS,
          loading: true
        });
      } else {
        yield put({
          type: actions.FETCHING_ALL_FINANCE_OPERATIONS,
          loading: true
        });
      }

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchAllFinanceOperationsAPI(payload, roleHeaderAuth);
      const result = apiResult.data;

      const listData = currentList && payload.loadMore && currentList.length > 0 ? currentList : [];
      const parseData =
        listData && listData.length > 0 ? listData.concat(result.data) : result.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_ALL_FINANCE_OPERATIONS_SUCCESS,
          loading: false,
          result: parseData,
          pagination: result.pagination,
          filter: {
            ...payload
          }
        });

        if (parseData.length > 0 && parseData[0] && parseData[0].id) {
          yield put({
            type: actions.FETCH_FINANCE_OPERATIONS_BY_ID,
            payload: parseData[0].id
          });
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_ALL_FINANCE_OPERATIONS_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.FETCH_ALL_FINANCE_OPERATIONS_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_ALL_FINANCE_OPERATIONS_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchFinanceOperationsByID() {
  yield takeEvery('FETCH_FINANCE_OPERATIONS_BY_ID', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_FINANCE_OPERATIONS_BY_ID,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchFinanceOperationsByIDAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_FINANCE_OPERATIONS_BY_ID_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });

        if (payload) {
          yield put({
            type: actions.FETCH_FINANCE_OPERATIONS_LOGS,
            payload: payload,
            pagination: {
              page: 0,
              limit: 20
            }
          });
        }
      } else {
        yield put({
          type: actions.FETCH_FINANCE_OPERATIONS_BY_ID_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_FINANCE_OPERATIONS_BY_ID_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchFinanceOperationsLogs() {
  yield takeEvery('FETCH_FINANCE_OPERATIONS_LOGS', function* ({ payload, pagination }) {
    try {
      const loadmore = pagination.loadMore;
      if (loadmore) {
        yield put({
          type: actions.LOADING_MORE_FINANCE_OPERATIONS_LOGS
        });
      } else {
        yield put({
          type: actions.FETCHING_FINANCE_OPERATIONS_LOGS,
          loading: true
        });
      }
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchFinanceOperationsLogsAPI(payload, pagination, roleHeaderAuth);
      const currentList = pagination.currentData && loadmore ? pagination.currentData : [];

      const result = apiResult.data;

      const parseData =
        currentList && currentList.length > 0
          ? currentList.concat(result.data.logs)
          : result.data.logs;

      const finalData =
        parseData && parseData.length > 0
          ? parseData.sort((a, b) => {
              const dateA = new Date(a.created_at);
              const dateB = new Date(b.created_at);
              return dateB - dateA;
            })
          : [];

      if (result.success) {
        yield put({
          type: actions.FETCH_FINANCE_OPERATIONS_LOGS_SUCCESS,
          loading: false,
          result: finalData,
          pagination: result ? result.data.pagination : null
        });
      } else {
        yield put({
          type: actions.FETCH_FINANCE_OPERATIONS_LOGS_FAILED,
          loading: false,
          payload: currentList
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_FINANCE_OPERATIONS_LOGS_FAILED,
        loading: false,
        payload: []
      });
    }
  });
}

export function* downloadVatExemptionFileOperations() {
  yield takeEvery('DOWNLOAD_VAT_EXEMPTION_FILE_FINANCE', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.DOWNLOADING_VAT_EXEMPTION_FILE_FINANCE,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield downloadVatExemptionFileOperationsAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.DOWNLOAD_VAT_EXEMPTION_FILE_FINANCE_SUCCESS,
          loading: false,
          message: 'Attachment downloaded successfully.'
        });
        if (result.url) {
          window.open(result.url, '_blank');
        }

        yield put({
          type: actions.FETCH_FINANCE_OPERATIONS_LOGS,
          payload: id,
          pagination: {
            page: 0,
            limit: 20
          }
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.DOWNLOAD_VAT_EXEMPTION_FILE_FINANCE_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.DOWNLOAD_VAT_EXEMPTION_FILE_FINANCE_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.DOWNLOAD_VAT_EXEMPTION_FILE_FINANCE_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* downloadPaymentProofFileOperations() {
  yield takeEvery('DOWNLOAD_PAYMENT_PROOF_FILE_FINANCE', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.DOWNLOADING_PAYMENT_PROOF_FILE_FINANCE,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield downloadPaymentProofFileOperationsAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.DOWNLOAD_PAYMENT_PROOF_FILE_FINANCE_SUCCESS,
          loading: false,
          message: 'Attachment downloaded successfully.'
        });
        if (result.url) {
          window.open(result.url, '_blank');
        }

        yield put({
          type: actions.FETCH_FINANCE_OPERATIONS_LOGS,
          payload: id,
          pagination: {
            page: 0,
            limit: 20
          }
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.DOWNLOAD_PAYMENT_PROOF_FILE_FINANCE_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.DOWNLOAD_PAYMENT_PROOF_FILE_FINANCE_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.DOWNLOAD_PAYMENT_PROOF_FILE_FINANCE_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* approveVatExemptionFile() {
  yield takeEvery('APPROVE_VAT_EXEMPTION_FILE', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.APPROVING_VAT_EXEMPTION_FILE,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield approveVatExemptionFileAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.APPROVE_VAT_EXEMPTION_FILE_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_ALL_FINANCE_OPERATIONS
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.APPROVE_VAT_EXEMPTION_FILE_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.APPROVE_VAT_EXEMPTION_FILE_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.APPROVE_VAT_EXEMPTION_FILE_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* rejectVatExemptionFile() {
  yield takeEvery('REJECT_VAT_EXEMPTION_FILE', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.REJECTING_VAT_EXEMPTION_FILE,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield rejectVatExemptionFileAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.REJECT_VAT_EXEMPTION_FILE_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_ALL_FINANCE_OPERATIONS
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.REJECT_VAT_EXEMPTION_FILE_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.REJECT_VAT_EXEMPTION_FILE_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.REJECT_VAT_EXEMPTION_FILE_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* confirmPaymentProofFile() {
  yield takeEvery('CONFIRM_PAYMENT_PROOF_FILE', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.CONFIRMING_PAYMENT_PROOF_FILE,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield confirmPaymentProofFileAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.CONFIRM_PAYMENT_PROOF_FILE_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_ALL_FINANCE_OPERATIONS
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.CONFIRM_PAYMENT_PROOF_FILE_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.CONFIRM_PAYMENT_PROOF_FILE_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.REJECT_VAT_EXEMPTION_FILE_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* sendMerchantInvoiceFile() {
  yield takeEvery('SEND_MERCHANT_INVOICE', function* ({ payload }) {
    try {
      yield put({
        type: actions.SENDING_MERCHANT_INVOICE,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield sendMerchantInvoiceFileAPI(payload, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.SEND_MERCHANT_INVOICE_SUCCESS,
          loading: false,
          message: result.message
        });
        if (payload && payload.operations_id) {
          yield put({
            type: actions.FETCH_FINANCE_OPERATIONS_BY_ID,
            payload: payload.operations_id
          });
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.SEND_MERCHANT_INVOICE_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.SEND_MERCHANT_INVOICE_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.SEND_MERCHANT_INVOICE_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* viewConfidentialBankDetails() {
  yield takeEvery('VIEW_CONFIDENTIAL_BANK_DETAILS', function* ({ payload }) {
    try {
      yield put({
        type: actions.VIEWING_CONFIDENTIAL_BANK_DETAILS,
        loading: true
      });

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield viewConfidentialBankDetailsAPI(payload, roleHeaderAuth);
      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.VIEW_CONFIDENTIAL_BANK_DETAILS_SUCCESS,
          loading: false,
          result: result.data
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.VIEW_CONFIDENTIAL_BANK_DETAILS_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.VIEW_CONFIDENTIAL_BANK_DETAILS_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.VIEW_CONFIDENTIAL_BANK_DETAILS_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* editInvoice() {
  yield takeEvery('EDIT_INVOICE', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.EDITING_INVOICE,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield editInvoiceAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.EDIT_INVOICE_SUCCESS,
          loading: false,
          message: result.message
        });
        if (id) {
          yield put({
            type: actions.FETCH_FINANCE_OPERATIONS_BY_ID,
            payload: id
          });
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.EDIT_INVOICE_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.EDIT_INVOICE_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.APPROVE_VAT_EXEMPTION_FILE_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* viewInvoicePDF() {
  yield takeEvery('VIEW_INVOICE_PDF', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.VIEWING_INVOICE_PDF,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield viewInvoicePDFAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.VIEW_INVOICE_PDF_SUCCESS,
          loading: false,
          url: result.url,
          message: result.message
        });

        yield put({
          type: actions.FETCH_FINANCE_OPERATIONS_LOGS,
          payload: id,
          pagination: {
            page: 0,
            limit: 20
          }
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.VIEW_INVOICE_PDF_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.VIEW_INVOICE_PDF_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.VIEW_INVOICE_PDF_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* viewVatReversalAttachment() {
  yield takeEvery('VIEW_VAT_REVERSAL_ATTACHMENT', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.VIEWING_VAT_REVERSAL_ATTACHMENT,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield viewVatReversalAttachmentAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.VIEW_VAT_REVERSAL_ATTACHMENT_SUCCESS,
          loading: false,
          url: result.url,
          message: result.message
        });

        yield put({
          type: actions.FETCH_FINANCE_OPERATIONS_LOGS,
          payload: id,
          pagination: {
            page: 0,
            limit: 20
          }
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.VIEW_VAT_REVERSAL_ATTACHMENT_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.VIEW_VAT_REVERSAL_ATTACHMENT_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.VIEW_VAT_REVERSAL_ATTACHMENT_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* viewPaymentProofPDF() {
  yield takeEvery('VIEW_PAYMENT_PROOF_PDF', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.VIEWING_PAYMENT_PROOF_PDF,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield viewPaymentProofPDFAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.VIEW_PAYMENT_PROOF_PDF_SUCCESS,
          loading: false,
          url: result.url,
          message: result.message
        });

        yield put({
          type: actions.FETCH_FINANCE_OPERATIONS_LOGS,
          payload: id,
          pagination: {
            page: 0,
            limit: 20
          }
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.VIEW_PAYMENT_PROOF_PDF_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.VIEW_PAYMENT_PROOF_PDF_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.VIEW_PAYMENT_PROOF_PDF_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* requestVatExemptReversal() {
  yield takeEvery('REQUEST_VAT_EXEMPT_REVERSAL', function* ({ urls, payload }) {
    try {
      yield put({
        type: actions.REQUESTING_VAT_EXEMPT_REVERSAL,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      
      let reversalAttachment = [];
      if (
        payload &&
        payload.reversal_attachment &&
        urls &&
        urls.reversal_attachment &&
        payload.reversal_attachment.length === urls.reversal_attachment.length
      ) {
        const dataFile = payload.reversal_attachment;
        dataFile.forEach(file => {
          if (urls.reversal_attachment.some(str => str.includes(file.name))) {
            let getURL = urls.reversal_attachment.find(str => str.includes(file.name));
            if (getURL) {
              uploadFileToS3(getURL, file);
              let currentObj = {
                name: file.name,
                file_type: file.file_type
              };
              reversalAttachment.push(currentObj);
            }
          }
        });

        yield delay(urls.reversal_attachment.length * 1000);
      }

      const apiResult = yield requestVatReversalAPI(
        { ...payload, reversal_attachment: reversalAttachment },
        roleHeaderAuth
      );
      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.REQUEST_VAT_EXEMPT_REVERSAL_SUCCESS,
          loading: false,
          message: result.message
        });
        if (payload && payload.operations_id) {
          yield put({
            type: actions.FETCH_FINANCE_OPERATIONS_BY_ID,
            payload: payload.operations_id
          });
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.REQUEST_VAT_EXEMPT_REVERSAL_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.REQUEST_VAT_EXEMPT_REVERSAL_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.REQUEST_VAT_EXEMPT_REVERSAL_FAILED,
        message: 'Failed to process request vat reversal',
        loading: false
      });
    }
  });
}

export function* fetchReversalRequestByID() {
  yield takeEvery('FETCH_REVERSAL_REQUEST_BY_ID', function* ({ id }) {
    try {
      yield put ({
        type: actions.FETCHING_REVERSAL_REQUEST_BY_ID,
        loading: true,
      });
      const roleHeaderAuth = yield getRoleHeader()
      const apiResult = yield fetchReversalRequestByIDAPI(id, roleHeaderAuth)

      const result = apiResult.data

      if (result.success) {
        yield put ({
          type: actions.FETCH_REVERSAL_REQUEST_BY_ID_SUCCESS,
          result: result ? result.data : null,
          loading: false
        })
      } else {
        yield put({
          type: actions.FETCH_REVERSAL_REQUEST_BY_ID_FAILED,
          loading: false
      });
      }

    } catch (error) {
      yield put({
        type: actions.FETCH_REVERSAL_REQUEST_BY_ID_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    } 
  });
}

export function* approveVatExemptReversal() {
  yield takeEvery('APPROVE_VAT_EXEMPT_REVERSAL', function* ({payload, id}) {
    try {
      yield put({
        type: actions.APPROVING_VAT_EXEMPT_REVERSAL,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader()

      const apiResult = yield approveVatExemptReversalAPI(payload, id, roleHeaderAuth)
      const result = apiResult.data

      if (result.success) {
        yield put({
          type: actions.APPROVE_VAT_EXEMPT_REVERSAL_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_ALL_FINANCE_OPERATIONS
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.APPROVE_VAT_EXEMPT_REVERSAL_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.APPROVE_VAT_EXEMPT_REVERSAL_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put ({
        type: actions.APPROVE_VAT_EXEMPT_REVERSAL_FAILED,
        message: 'Failed to process request',
        loading: false
      })
    }
  }); 
}

export function* rejectVatExemptReversal() {
  yield takeEvery('REJECT_VAT_EXEMPT_REVERSAL', function* ({payload, id}) {
    try {
      yield put({
        type: actions.REJECTING_VAT_EXEMPT_REVERSAL,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader()

      const apiResult = yield rejectVatExemptReversalAPI(payload, id, roleHeaderAuth)
      const result = apiResult.data

      if (result.success) {
        yield put({
          type: actions.REJECT_VAT_EXEMPT_REVERSAL_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_ALL_FINANCE_OPERATIONS
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.REJECT_VAT_EXEMPT_REVERSAL_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.REJECT_VAT_EXEMPT_REVERSAL_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put ({
        type: actions.REJECT_VAT_EXEMPT_REVERSAL_FAILED,
        message: 'Failed to process request',
        loading: false
      })
    }
  }); 
}

export function* requestInvoiceApproval() {
  yield takeEvery('REQUEST_INVOICE_APPROVAL', function* ({ urls, payload }) {
    try {
      yield put({
        type: actions.REQUESTING_INVOICE_APPROVAL,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();

      let eSignature = [];
      if (
        payload &&
        payload.e_signature &&
        urls &&
        urls.e_signature &&
        payload.e_signature.length === urls.e_signature.length
      ) {
        const dataFile = payload.e_signature;
        dataFile.forEach(file => {
          if (urls.e_signature.some(str => str.includes(file.name))) {
            let getURL = urls.e_signature.find(str => str.includes(file.name));
            if (getURL) {
              uploadFileToS3(getURL, file);
              let currentObj = {
                name: file.name,
                file_type: file.file_type
              };
              eSignature.push(currentObj);
            }
          }
        });

        yield delay(urls.e_signature.length * 1000);
      }

      const apiResult = yield requestInvoiceApprovalAPI(
        { ...payload, e_signature: eSignature },
        roleHeaderAuth
      );
      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.REQUEST_INVOICE_APPROVAL_SUCCESS,
          loading: false,
          message: result.message
        });
        if (payload && payload.operations_id) {
          yield put({
            type: actions.FETCH_FINANCE_OPERATIONS_BY_ID,
            payload: payload.operations_id
          });
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.REQUEST_INVOICE_APPROVAL_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.REQUEST_INVOICE_APPROVAL_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.REQUEST_INVOICE_APPROVAL_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* approveInvoice() {
  yield takeEvery('APPROVE_INVOICE', function* ({ urls, payload }) {
    try {
      yield put({
        type: actions.APPROVING_INVOICE,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();

      let eSignature = [];
      if (
        payload &&
        payload.e_signature &&
        urls &&
        urls.e_signature &&
        payload.e_signature.length === urls.e_signature.length
      ) {
        const dataFile = payload.e_signature;
        dataFile.forEach(file => {
          if (urls.e_signature.some(str => str.includes(file.name))) {
            let getURL = urls.e_signature.find(str => str.includes(file.name));
            if (getURL) {
              uploadFileToS3(getURL, file);
              let currentObj = {
                name: file.name,
                file_type: file.file_type
              };
              eSignature.push(currentObj);
            }
          }
        });

        yield delay(urls.e_signature.length * 1000);
      }

      const apiResult = yield approveInvoiceAPI(
        { ...payload, e_signature: eSignature },
        roleHeaderAuth
      );
      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.APPROVE_INVOICE_SUCCESS,
          loading: false,
          message: result.message
        });
        if (payload && payload.operations_id) {
          yield put({
            type: actions.FETCH_FINANCE_OPERATIONS_BY_ID,
            payload: payload.operations_id
          });
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.APPROVE_INVOICE_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.APPROVE_INVOICE_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.APPROVE_INVOICE_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* rejectInvoice() {
  yield takeEvery('REJECT_INVOICE', function* ({ urls, payload }) {
    try {
      yield put({
        type: actions.REJECTING_INVOICE,
        loading: true
      });

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield rejectInvoiceAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.REJECT_INVOICE_SUCCESS,
          loading: false,
          message: result.message
        });
        if (payload && payload.operations_id) {
          yield put({
            type: actions.FETCH_FINANCE_OPERATIONS_BY_ID,
            payload: payload.operations_id
          });
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.REJECT_INVOICE_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.REJECT_INVOICE_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.REJECT_INVOICE_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchAllFinanceUsers() {
  yield takeEvery('FETCH_ALL_FINANCE_USERS', function* () {
    try {
      yield put({
        type: actions.FETCHING_ALL_FINANCE_USERS,
        loading: true
      });

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchAllFinanceUsersAPI(roleHeaderAuth);
      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_ALL_FINANCE_USERS_SUCCESS,
          loading: false,
          result: result.data
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_ALL_FINANCE_USERS_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.FETCH_ALL_FINANCE_USERS_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_ALL_FINANCE_USERS_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* getS3UrlESignature() {
  yield takeEvery('STORE_ESIGNATURE', function* ({ key, files }) {
    try {
      yield put({
        type: actions.STORING_ESIGNATURE,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield getURLsForCaseFilesAPI(key, files, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.STORE_ESIGNATURE_SUCCESS,
          loading: false,
          result: result ? result.data : null
        });
      } else {
        yield put({
          type: actions.STORE_ESIGNATURE_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.STORE_ESIGNATURE_FAILED,
        loading: false
      });
    }
  });
}

export function* getS3UrlsReversalAttachment() {
  yield takeEvery('STORE_VAT_REVERSAL_ATTACHMENT', function* ({ key, files }) {
    try {
      yield put({
        type: actions.STORING_VAT_REVERSAL_ATTACHMENT,
        loading: true
      });

      const state = yield select();
      const presignedUrlsReversalAttachment = state.Transaction.presignedUrlsReversalAttachment;

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield getURLsForReversalAttachmentAPI(key, files, roleHeaderAuth);
      const result = apiResult.data;

      if (result.success) {
        const urlsArr = [];
        if (presignedUrlsReversalAttachment && presignedUrlsReversalAttachment.length > 0) {
          urlsArr.push(...presignedUrlsReversalAttachment);
        }
        urlsArr.push(...result.data);

        yield put({
          type: actions.STORE_VAT_REVERSAL_ATTACHMENT_SUCCESS,
          loading: false,
          result: urlsArr
        });
      } else {
        yield put({
          type: actions.STORE_VAT_REVERSAL_ATTACHMENT_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.STORE_VAT_REVERSAL_ATTACHMENT_FAILED,
        loading: false
      });
    }
  });
}

export function* getS3UrlsPaymentProof() {
  yield takeEvery('STORE_PAYMENT_PROOF_FOR_UPLOAD', function* ({ key, files }) {
    try {
      yield put({
        type: actions.STORING_PAYMENT_PROOF_FOR_UPLOAD,
        loading: true
      });
      const state = yield select();
      const presignedUrlsPaymentProof = state.Transaction.presignedUrlsPaymentProof;

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield getURLsForMerchantFilesAPI(key, files, roleHeaderAuth);
      const result = apiResult.data;

      if (result.success) {
        const urlsArr = [];
        if (presignedUrlsPaymentProof && presignedUrlsPaymentProof.length > 0) {
          urlsArr.push(...presignedUrlsPaymentProof);
        }
        urlsArr.push(...result.data);

        yield put({
          type: actions.STORE_PAYMENT_PROOF_FOR_UPLOAD_SUCCESS,
          loading: false,
          result: urlsArr
        });
      } else {
        yield put({
          type: actions.STORE_PAYMENT_PROOF_FOR_UPLOAD_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.STORE_PAYMENT_PROOF_FOR_UPLOAD_FAILED,
        loading: false
      });
    }
  });
}

export function* managePaymentProofFiles() {
  yield takeEvery('MANAGE_PAYMENT_PROOF_FILES', function* ({ urls, payload, id }) {
    try {
      yield put({
        type: actions.MANAGING_PAYMENT_PROOF_FILES,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();

      let paymentProofData = [];
      if (
        payload &&
        payload.payment_proof_files &&
        payload.payment_proof_files.length === urls.payment_proof_files.length
      ) {
        const dataFile = payload.payment_proof_files;
        dataFile.forEach(file => {
          if (urls.payment_proof_files.some(str => str.includes(file.name))) {
            let getURL = urls.payment_proof_files.find(str => str.includes(file.name));
            if (getURL) {
              uploadFileToS3(getURL, file);
              let currentObj = {
                name: file.name,
                file_type: file.file_type
              };
              paymentProofData.push(currentObj);
            }
          }
        });

        yield delay(urls.payment_proof_files.length * 1000);
      }

      const apiResult = yield managePaymentProofFilesAPI(
        {
          ...payload,
          payment_proof_files: paymentProofData
        },
        id,
        roleHeaderAuth
      );

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.MANAGE_PAYMENT_PROOF_FILES_SUCCESS,
          loading: false,
          message: result.message
        });

        yield put({
          type: actions.FETCH_ALL_FINANCE_OPERATIONS
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.MANAGE_PAYMENT_PROOF_FILES_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.MANAGE_PAYMENT_PROOF_FILES_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.MANAGE_PAYMENT_PROOF_FILES_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchAllSettlementCycleData() {
  yield takeEvery('FETCH_ALL_SETTLEMENT_CYCLE', function* ({ payload, pagination }) {
    try {
      if (pagination?.loadMore) {
        yield put({
          type: actions.LOADING_MORE_SETTLEMENT_CYCLE,
          loading: true
        });
      } else {
        yield put({
          type: actions.FETCHING_ALL_SETTLEMENT_CYCLE,
          loading: true
        });
      }

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchAllSettlementCycleDataAPI(payload, pagination, roleHeaderAuth);
      const result = apiResult.data;

      const listData =
        pagination?.currentList && pagination?.loadMore && pagination?.currentList?.length > 0
          ? pagination?.currentList
          : [];

      const parseData =
        listData && listData.length > 0 ? listData.concat(result.data) : result.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_ALL_SETTLEMENT_CYCLE_SUCCESS,
          loading: false,
          result: parseData,
          pagination: result?.pagination,
          filter: payload
        });

        if (parseData.length > 0 && parseData[0] && parseData[0].id) {
          yield put({
            type: actions.FETCH_SETTLEMENT_CYCLE_BY_ID,
            payload: parseData[0].id
          });
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_ALL_SETTLEMENT_CYCLE_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.FETCH_ALL_SETTLEMENT_CYCLE_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_ALL_SETTLEMENT_CYCLE_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchSettlementCycleByID() {
  yield takeEvery('FETCH_SETTLEMENT_CYCLE_BY_ID', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_SETTLEMENT_CYCLE_BY_ID,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchSettlementCycleByIDAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_SETTLEMENT_CYCLE_BY_ID_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });

        if (payload) {
          yield put({
            type: actions.FETCH_SETTLEMENT_CYCLE_LOGS,
            payload: payload,
            pagination: {
              page: 0,
              limit: 20
            }
          });
        }
      } else {
        yield put({
          type: actions.FETCH_SETTLEMENT_CYCLE_BY_ID_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_SETTLEMENT_CYCLE_BY_ID_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchSettlementRateByID() {
  yield takeEvery('FETCH_SETTLEMENT_RATE_BY_ID', function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_SETTLEMENT_RATE_BY_ID,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchSettlementRateByIDAPI(payload, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.FETCH_SETTLEMENT_RATE_BY_ID_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
        yield put({
          type: actions.FETCH_FEE_HISTORY,
          payload: payload,
          pagination: {
            page: 0,
            limit: 20
          }
        });
      } else {
        yield put({
          type: actions.FETCH_SETTLEMENT_RATE_BY_ID_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_SETTLEMENT_RATE_BY_ID_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* addSettlementCycle() {
  yield takeEvery('ADD_SETTLEMENT_CYCLE', function* ({ payload }) {
    try {
      yield put({
        type: actions.ADDING_SETTLEMENT_CYCLE,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield addSettlementCycleAPI(payload, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.ADD_SETTLEMENT_CYCLE_SUCCESS,
          loading: false,
          message: result.message
        });

        yield put({
          type: actions.FETCH_ALL_SETTLEMENT_CYCLE
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.ADD_SETTLEMENT_CYCLE_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.ADD_SETTLEMENT_CYCLE_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.ADD_SETTLEMENT_CYCLE_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}
export function* editSettlementCycle() {
  yield takeEvery('EDIT_SETTLEMENT_CYCLE', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.EDITING_SETTLEMENT_CYCLE,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield editSettlementCycleAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.EDIT_SETTLEMENT_CYCLE_SUCCESS,
          loading: false,
          message: result.message,
          id: id,
          data: result?.data
        });

        // yield put({
        //   type: actions.FETCH_ALL_SETTLEMENT_CYCLE
        // });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.EDIT_SETTLEMENT_CYCLE_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.EDIT_SETTLEMENT_CYCLE_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.EDIT_SETTLEMENT_CYCLE_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* createBillingAdditionalFee() {
  yield takeEvery('CREATE_BILLING_ADDITIONAL_FEE', function* ({ payload }) {
    try {
      yield put({
        type: actions.CREATING_BILLING_ADDITIONAL_FEE,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield createBillingAdditionalFeeAPI(payload, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.CREATE_BILLING_ADDITIONAL_FEE_SUCCESS,
          loading: false,
          message: result.message
        });

        yield put({
          type: actions.FETCH_ALL_BILLING_ADDITIONAL_FEE
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.CREATE_BILLING_ADDITIONAL_FEE_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.CREATE_BILLING_ADDITIONAL_FEE_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.CREATE_BILLING_ADDITIONAL_FEE_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchAllBillingAdditionalFeeData() {
  yield takeEvery('FETCH_ALL_BILLING_ADDITIONAL_FEE', function* ({ payload, currentList }) {
    try {
      if (payload && payload.loadMore) {
        yield put({
          type: actions.LOADING_MORE_BILLING_ADDITIONAL_FEE,
          loading: true
        });
      } else {
        yield put({
          type: actions.FETCHING_ALL_BILLING_ADDITIONAL_FEE,
          loading: true
        });
      }

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchAllBillingAdditionalFeeDataAPI(payload, roleHeaderAuth);
      const result = apiResult.data;

      const listData = currentList && payload.loadMore && currentList.length > 0 ? currentList : [];
      const parseData =
        listData && listData.length > 0 ? listData.concat(result.data) : result.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_ALL_BILLING_ADDITIONAL_FEE_SUCCESS,
          loading: false,
          result: parseData,
          pagination: result.pagination,
          filter: {
            ...payload
          }
        });

        if (parseData.length > 0 && parseData[0] && parseData[0].id) {
          yield put({
            type: actions.FETCH_BILLING_ADDITIONAL_FEE_BY_ID,
            payload: parseData[0].id,
            merchantID: parseData[0].merchant_id
          });
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_ALL_BILLING_ADDITIONAL_FEE_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.FETCH_ALL_BILLING_ADDITIONAL_FEE_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_ALL_BILLING_ADDITIONAL_FEE_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchBillingAdditionalFeeByID() {
  yield takeEvery('FETCH_BILLING_ADDITIONAL_FEE_BY_ID', function* ({ payload, merchantID }) {
    try {
      yield put({
        type: actions.FETCHING_BILLING_ADDITIONAL_FEE_BY_ID,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchBillingAdditionalFeeByIDAPI(payload, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.FETCH_BILLING_ADDITIONAL_FEE_BY_ID_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });

        if (merchantID) {
          yield put({
            type: actions.FETCH_BILLING_CONFIGURATION_LOGS,
            payload: merchantID,
            pagination: {
              page: 0,
              limit: 20
            }
          });
        }
      } else {
        yield put({
          type: actions.FETCH_BILLING_ADDITIONAL_FEE_BY_ID_FAILED,
          message: result.message,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_BILLING_ADDITIONAL_FEE_BY_ID_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* updateBillingAdditionalFee() {
  yield takeEvery('UPDATE_BILLING_ADDITIONAL_FEE', function* ({ payload }) {
    try {
      yield put({
        type: actions.UPDATING_BILLING_ADDITIONAL_FEE,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield updateBillingAdditionalFeeAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.UPDATE_BILLING_ADDITIONAL_FEE_SUCCESS,
          loading: false,
          message: result.message
        });

        if (payload?.id) {
          yield put({
            type: actions.FETCH_BILLING_ADDITIONAL_FEE_BY_ID,
            payload: payload.id,
            merchantID: payload.merchant_id
          });
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.UPDATE_BILLING_ADDITIONAL_FEE_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.UPDATE_BILLING_ADDITIONAL_FEE_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.UPDATE_BILLING_ADDITIONAL_FEE_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchBillingConfigurationLogs() {
  yield takeEvery('FETCH_BILLING_CONFIGURATION_LOGS', function* ({ payload, pagination }) {
    try {
      const loadmore = pagination.loadMore;
      if (loadmore) {
        yield put({
          type: actions.LOADING_MORE_BILLING_CONFIGURATION_LOGS
        });
      } else {
        yield put({
          type: actions.FETCHING_BILLING_CONFIGURATION_LOGS,
          loading: true
        });
      }
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchBillingConfigurationLogsAPI(payload, pagination, roleHeaderAuth);
      const currentList = pagination.currentData && loadmore ? pagination.currentData : [];

      const result = apiResult.data;

      const parseData =
        currentList && currentList.length > 0
          ? currentList.concat(result.data.logs)
          : result.data.logs;

      const finalData =
        parseData && parseData.length > 0
          ? parseData.sort((a, b) => {
              const dateA = new Date(a.created_at);
              const dateB = new Date(b.created_at);
              return dateB - dateA;
            })
          : [];

      if (result.success) {
        yield put({
          type: actions.FETCH_BILLING_CONFIGURATION_LOGS_SUCCESS,
          loading: false,
          result: finalData,
          pagination: result ? result.data.pagination : null
        });
      } else {
        yield put({
          type: actions.FETCH_BILLING_CONFIGURATION_LOGS_FAILED,
          loading: false,
          payload: currentList
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_BILLING_CONFIGURATION_LOGS_FAILED,
        loading: false,
        payload: []
      });
    }
  });
}

export function* getS3UrlsAddendumFile() {
  yield takeEvery('STORE_ADDENDUM_FOR_UPLOAD', function* ({ payload }) {
    try {
      yield put({
        type: actions.STORING_ADDENDUM_FOR_UPLOAD,
        loading: true
      });
      const state = yield select();
      const presignedUrlsAddendum = state.Transaction.presignedUrlsAddendum;

      const roleHeaderAuth = null;
      const apiResult = yield getURLsForAddendumFilesAPI(payload, roleHeaderAuth);
      const result = apiResult.data;

      if (result.success) {
        const urlsArr = [];
        if (presignedUrlsAddendum && presignedUrlsAddendum.length > 0) {
          urlsArr.push(...presignedUrlsAddendum);
        }
        urlsArr.push(...result.data);

        yield put({
          type: actions.STORE_ADDENDUM_FOR_UPLOAD_SUCCESS,
          loading: false,
          result: urlsArr
        });
      } else {
        yield put({
          type: actions.STORE_ADDENDUM_FOR_UPLOAD_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.STORE_ADDENDUM_FOR_UPLOAD_FAILED,
        loading: false
      });
    }
  });
}

export function* generateSummaryBreakdownReport() {
  yield takeEvery('GENERATE_SUMMARY_BREAKDOWN_REPORT', function* ({ payload }) {
    try {
      yield put({
        type: actions.GENERATING_SUMMARY_BREAKDOWN_REPORT,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield generateSummaryBreakdownReportAPI(payload, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.GENERATE_SUMMARY_BREAKDOWN_REPORT_SUCCESS,
          loading: false,
          message: result.message
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.GENERATE_SUMMARY_BREAKDOWN_REPORT_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.GENERATE_SUMMARY_BREAKDOWN_REPORT_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.GENERATE_SUMMARY_BREAKDOWN_REPORT_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* generateSummaryBreakdownReportV2() {
  yield takeEvery(actions.GENERATE_SUMMARY_BREAKDOWN_REPORT_V2, function* ({ payload }) {
    try {
      yield put({
        type: actions.GENERATING_SUMMARY_BREAKDOWN_REPORT_V2,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield generateSummaryBreakdownReportV2API(payload, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.GENERATE_SUMMARY_BREAKDOWN_REPORT_V2_SUCCESS,
          loading: false,
          message: result.message
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.GENERATE_SUMMARY_BREAKDOWN_REPORT_V2_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.GENERATE_SUMMARY_BREAKDOWN_REPORT_V2_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.GENERATE_SUMMARY_BREAKDOWN_REPORT_V2_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* editMerchantPaymentChannelSettlement() {
  yield takeEvery('EDIT_MERCHANT_PAYMENT_CHANNEL_SETTLEMENT', function* ({ payload, id }) {
    try {
      yield put({
        type: actions.EDITING_MERCHANT_PAYMENT_CHANNEL_SETTLEMENT,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield editMerchantPaymentChannelSettlementAPI(payload, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.EDIT_MERCHANT_PAYMENT_CHANNEL_SETTLEMENT_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_SETTLEMENT_RATE_BY_ID,
          payload: payload.merchant_settlement_cycle_id
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.EDIT_MERCHANT_PAYMENT_CHANNEL_SETTLEMENT_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.EDIT_MERCHANT_PAYMENT_CHANNEL_SETTLEMENT_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.EDIT_MERCHANT_PAYMENT_CHANNEL_SETTLEMENT_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchFeeHistory() {
  yield takeEvery('FETCH_FEE_HISTORY', function* ({ payload, pagination }) {
    try {
      const loadmore = pagination.loadMore;
      if (loadmore) {
        yield put({
          type: actions.LOADING_MORE_FEE_HISTORY
        });
      } else {
        yield put({
          type: actions.FETCHING_FEE_HISTORY,
          loading: true
        });
      }
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchFeeHistoryAPI(payload, pagination, roleHeaderAuth);
      const currentList = pagination.currentData && loadmore ? pagination.currentData : [];

      const result = apiResult.data;

      const parseData =
        currentList && currentList.length > 0
          ? currentList.concat(result.data.logs)
          : result.data.logs;

      const finalData =
        parseData && parseData.length > 0
          ? parseData.sort((a, b) => {
              const dateA = new Date(a.created_at);
              const dateB = new Date(b.created_at);
              return dateB - dateA;
            })
          : [];

      if (result.success) {
        yield put({
          type: actions.FETCH_FEE_HISTORY_SUCCESS,
          loading: false,
          result: finalData,
          pagination: result ? result.data.pagination : null
        });
      } else {
        yield put({
          type: actions.FETCH_FEE_HISTORY_FAILED,
          loading: false,
          payload: currentList
        });
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_FEE_HISTORY_FAILED,
        loading: false,
        payload: []
      });
    }
  });
}

export function* createChangeRequestRates() {
  yield takeEvery('CREATE_CHANGE_REQUEST_RATES', function* ({ urls, payload }) {
    try {
      yield put({
        type: actions.CREATING_CHANGE_REQUEST_RATES,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();

      let addendumData = [];
      if (
        payload &&
        payload.addendum_files &&
        payload.addendum_files.length === urls.addendum_files.length
      ) {
        const dataFile = payload.addendum_files;
        dataFile.forEach(file => {
          if (urls.addendum_files.some(str => str.includes(file.name))) {
            let getURL = urls.addendum_files.find(str => str.includes(file.name));
            if (getURL) {
              uploadFileToS3(getURL, file);
              let currentObj = {
                name: file.name,
                file_type: file.file_type
              };
              addendumData.push(currentObj);
            }
          }
        });
      }
      const addendumLength = (urls?.addendum_files ?? []).length;

      yield delay(addendumLength * 1000);

      // const apiResult = yield editMerchantPaymentChannelSettlementAPI(payload, roleHeaderAuth);
      const apiResult = yield createChangeRequestRatesAPI(
        {
          ...payload,
          addendum_files: addendumData
        },
        roleHeaderAuth
      );

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.CREATE_CHANGE_REQUEST_RATES_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_SETTLEMENT_RATE_BY_ID,
          payload: payload.merchant_settlement_cycle_id
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.CREATE_CHANGE_REQUEST_RATES_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.CREATE_CHANGE_REQUEST_RATES_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.CREATE_CHANGE_REQUEST_RATES_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* rejectChangeRequestRates() {
  yield takeEvery('REJECT_CHANGE_REQUEST_RATES', function* ({ payload }) {
    try {
      yield put({
        type: actions.REJECTING_CHANGE_REQUEST_RATES,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield rejectChangeRequestRatesAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.REJECT_CHANGE_REQUEST_RATES_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_SETTLEMENT_RATE_BY_ID,
          payload: payload.active_settlement_cycle_id
        });
      } else {
        yield put({
          type: actions.REJECT_CHANGE_REQUEST_RATES_FAILED,
          message: 'Failed to process request',
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.REJECT_CHANGE_REQUEST_RATES_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* approveChangeRequestRatesBySales() {
  yield takeEvery('APPROVE_CHANGE_REQUEST_RATES_BY_SALES', function* ({ payload }) {
    try {
      yield put({
        type: actions.APPROVING_CHANGE_REQUEST_RATES_BY_SALES,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield approveChangeRequestRatesBySalesAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.APPROVE_CHANGE_REQUEST_RATES_BY_SALES_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_SETTLEMENT_RATE_BY_ID,
          payload: payload.active_settlement_cycle_id
        });
      } else {
        yield put({
          type: actions.APPROVE_CHANGE_REQUEST_RATES_BY_SALES_FAILED,
          message: 'Failed to process request',
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.APPROVE_CHANGE_REQUEST_RATES_BY_SALES_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* approveChangeRequestRatesByFinance() {
  yield takeEvery('APPROVE_CHANGE_REQUEST_RATES_BY_FINANCE', function* ({ payload }) {
    try {
      yield put({
        type: actions.APPROVING_CHANGE_REQUEST_RATES_BY_FINANCE,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield approveChangeRequestRatesByFinanceAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.APPROVE_CHANGE_REQUEST_RATES_BY_FINANCE_SUCCESS,
          loading: false,
          message: result.message
        });
        yield put({
          type: actions.FETCH_SETTLEMENT_RATE_BY_ID,
          payload: payload.active_settlement_cycle_id
        });
      } else {
        yield put({
          type: actions.APPROVE_CHANGE_REQUEST_RATES_BY_FINANCE_FAILED,
          message: 'Failed to process request',
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.APPROVE_CHANGE_REQUEST_RATES_BY_FINANCE_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* downloadAddendumDocument() {
  yield takeEvery('DOWNLOAD_ADDENDUM_DOCUMENT', function* ({ id, payload }) {
    try {
      yield put({
        type: actions.DOWNLOADING_ADDENDUM_DOCUMENT,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield downloadAddendumDocumentAPI(id, payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.DOWNLOAD_ADDENDUM_DOCUMENT_SUCCESS,
          loading: false,
          message: 'Attachment downloaded successfully.'
        });
        if (result.url) {
          window.open(result.url, '_blank');
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.DOWNLOAD_ADDENDUM_DOCUMENT_FAILED,
            message: `Endpoint not found`,
            loading: false
          });
        } else {
          yield put({
            type: actions.DOWNLOAD_ADDENDUM_DOCUMENT_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.DOWNLOAD_ADDENDUM_DOCUMENT_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchAllGeneratedSettlementSummaryReportData() {
  yield takeEvery(
    'FETCH_ALL_GENERATED_SETTLEMENT_SUMMARY_REPORT_DATA',
    function* ({ payload, pagination }) {
      try {
        yield put({
          type: actions.FETCHING_ALL_GENERATED_SETTLEMENT_SUMMARY_REPORT_DATA,
          loading: true
        });
        const roleHeaderAuth = yield getRoleHeader();
        const apiResult = yield fetchAllGeneratedSettlementSummaryReportDataAPI(
          payload,
          pagination,
          roleHeaderAuth
        );

        const result = apiResult.data;

        if (result.success) {
          yield put({
            type: actions.FETCH_ALL_GENERATED_SETTLEMENT_SUMMARY_REPORT_DATA_SUCCESS,
            loading: false,
            result: result ? result.data : null,
            pagination: result ? result.pagination : null
          });
        } else {
          yield put({
            type: actions.FETCH_ALL_GENERATED_SETTLEMENT_SUMMARY_REPORT_DATA_FAILED,
            loading: false
          });
        }
      } catch (error) {
        yield put({
          type: actions.FETCH_ALL_GENERATED_SETTLEMENT_SUMMARY_REPORT_DATA_FAILED,
          loading: false
        });
      }
    }
  );
}

export function* downloadSettlementSummaryReport() {
  yield takeEvery('DOWNLOAD_SUMMARY_REPORT', function* ({ payload }) {
    try {
      yield put({
        type: actions.DOWNLOADING_SETTLEMENT_SUMMARY_REPORT,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield downloadSummaryReportAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.DOWNLOAD_SETTLEMENT_SUMMARY_REPORT_SUCCESS,
          loading: false,
          message: 'Settlement summary report downloaded successfully.'
        });

        if (result.url) {
          window.location.href = result.url;
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.DOWNLOAD_SETTLEMENT_SUMMARY_REPORT_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.DOWNLOAD_SETTLEMENT_SUMMARY_REPORT_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.DOWNLOAD_SETTLEMENT_SUMMARY_REPORT_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* saveSummaryBreakdownReportPChannelFilter() {
  yield takeEvery('SAVE_SUMMARY_BREAKDOWN_REPORT_PCHANNEL_FILTER', function* ({ payload }) {
    try {
      yield put({
        type: actions.SAVING_SUMMARY_BREAKDOWN_REPORT_PCHANNEL_FILTER,
        loading: true
      });

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield saveSummaryBreakdownReportPchannelFilterAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.SAVE_SUMMARY_BREAKDOWN_REPORT_PCHANNEL_FILTER_SUCCESS,
          isError: false,
          message: 'Successfully filtered out payment channels.'
        });

        yield put({
          type: actions.FETCH_SUMMARY_BREAKDOWN_REPORT_PCHANNEL_FILTER,
          loading: true
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.SAVE_SUMMARY_BREAKDOWN_REPORT_PCHANNEL_FILTER_FAILED,
            isError: true,
            message: 'Failed filtering out payment channels.'
          });
        } else {
          yield put({
            type: actions.SAVE_SUMMARY_BREAKDOWN_REPORT_PCHANNEL_FILTER_FAILED,
            isError: true,
            message: 'Failed filtering out payment channels.'
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.SAVE_SUMMARY_BREAKDOWN_REPORT_PCHANNEL_FILTER_FAILED,
        isError: true,
        message: 'Failed filtering out payment channels.'
      });
    }
  });
}

export function* fetchSummaryBreakdownReportPChannelFilter() {
  yield takeEvery('FETCH_SUMMARY_BREAKDOWN_REPORT_PCHANNEL_FILTER', function* () {
    try {
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchSummaryBreakdownReportPchannelFilterAPI(roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.SET_SUMMARY_BREAKDOWN_REPORT_PCHANNEL_FILTER,
          payload: result.data.selected_pchannels
        });
      }
    } catch (error) {
      yield put({
        type: actions.SAVE_SUMMARY_BREAKDOWN_REPORT_PCHANNEL_FILTER_FAILED,
        isError: true,
        message: 'Failed filtering out payment channels.'
      });
    }
  });
}

export function* tagAsFloating() {
  yield takeEvery('TAG_AS_FLOATING', function* ({ payload }) {
    try {
      yield put({
        type: actions.TAGGING_AS_FLOATING,
        loading: true
      });
      const state = yield select();
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield tagAsFloatingAPI(payload, roleHeaderAuth);
      const paymentChannel = state.Tools.uploadedChannel.p_channel;

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.TAG_AS_FLOATING_SUCCESS,
          loading: false,
          message: result.message
        });

        if (paymentChannel) {
          const logPagination = state.Tools.currentItemLogPagination
            ? state.Tools.currentItemLogPagination
            : { page: 0, limit: 10 };
          yield put({
            type: toolsAction.FETCH_LOGS_BY_ITEM_ID,
            id: paymentChannel,
            payload: {},
            pagination: logPagination
          });
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.TAG_AS_FLOATING_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.TAG_AS_FLOATING_FAILED,
            message: result && result.message ? result.message : 'No transaction found.',
            loading: false
          });
        }

        if (paymentChannel) {
          const logPagination = state.Tools.currentItemLogPagination
            ? state.Tools.currentItemLogPagination
            : { page: 0, limit: 10 };
          yield put({
            type: toolsAction.FETCH_LOGS_BY_ITEM_ID,
            id: paymentChannel,
            payload: {},
            pagination: logPagination
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.TAG_AS_FLOATING_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* findSingleTransactionLoosely() {
  yield takeEvery('FIND_SINGLE_TRANSACTION_LOOSELY', function* ({ payload }) {
    try {
      yield put({
        type: actions.FINDING_SINGLE_TRANSACTION_LOOSELY,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield findSingleTransactionLooselyAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FIND_SINGLE_TRANSACTION_LOOSELY_SUCCESS,
          loading: false,
          // message: result.message,
          data: result.data,
          payload: payload && payload.transaction
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FIND_SINGLE_TRANSACTION_LOOSELY_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.FIND_SINGLE_TRANSACTION_LOOSELY_FAILED,
            message: result && result.message ? result.message : 'No transaction found.',
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FIND_SINGLE_TRANSACTION_LOOSELY_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* getURLSforUploadedReconProof() {
  yield takeEvery('STORE_RECON_PROOF_FOR_UPLOAD', function* ({ key, files }) {
    try {
      yield put({
        type: actions.STORING_RECON_PROOF_FOR_UPLOAD,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield getURLsForCaseFilesAPI(key, files, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.STORE_RECON_PROOF_FOR_UPLOAD_SUCCESS,
          loading: false,
          result: result ? result.data : null
        });
      } else {
        yield put({
          type: actions.STORE_RECON_PROOF_FOR_UPLOAD_FAILED,
          loading: false
        });
      }
    } catch (error) {
      yield put({
        type: actions.STORE_RECON_PROOF_FOR_UPLOAD_FAILED,
        loading: false
      });
    }
  });
}

export function* confirmManualRecon() {
  yield takeEvery('CONFIRM_MANUAL_RECON', function* ({ urls, payload, filter }) {
    try {
      yield put({
        type: actions.CONFIRMING_MANUAL_RECON,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const state = yield select();
      const paymentChannel = state.Tools.uploadedChannel.p_channel;

      let finalDataForUpload = [];
      if (payload && payload.proof_of_payment.length === urls.length) {
        const dataFile = payload.proof_of_payment;
        dataFile.forEach(file => {
          if (urls.some(str => str.includes(file.name))) {
            let getURL = urls.find(str => str.includes(file.name));
            if (getURL) {
              uploadFileToS3(getURL, file);
              let currentObj = {
                name: file.name,
                file_type: file.file_type
              };
              finalDataForUpload.push(currentObj);
            }
          }
        });

        yield delay(urls.length * 1000);
      }

      const apiResult = yield confirmManualReconAPI(
        { ...payload, proof_of_payment: finalDataForUpload },
        roleHeaderAuth
      );
      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.CONFIRM_MANUAL_RECON_SUCCESS,
          loading: false,
          message: result.message
        });

        if (paymentChannel) {
          const logPagination = state.Tools.currentItemLogPagination
            ? state.Tools.currentItemLogPagination
            : { page: 0, limit: 10 };
          yield put({
            type: toolsAction.FETCH_LOGS_BY_ITEM_ID,
            id: paymentChannel,
            payload: {},
            pagination: logPagination
          });
        }

        if (filter) {
          yield put({
            type: actions.FETCH_RECONCILIATION_DATA_BY_PCHANNEL,
            payload: {
              ...filter,
              pagination: {
                page: 0,
                limit: 20
              }
            }
          });
          yield put({
            type: actions.FETCH_COLLATED_DATA_BY_PCHANNEL,
            payload: {
              ...filter,
              pagination: {
                page: 0,
                limit: 20
              }
            }
          });
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.CONFIRM_MANUAL_RECON_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.CONFIRM_MANUAL_RECON_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      console.log(error);
      yield put({
        type: actions.CONFIRM_MANUAL_RECON_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* downloadManualReconProof() {
  yield takeEvery('DOWNLOAD_MANUAL_RECON_PROOF', function* ({ payload }) {
    try {
      yield put({
        type: actions.DOWNLOADING_MANUAL_RECON_PROOF,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield downloadManualReconProofAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.DOWNLOAD_MANUAL_RECON_PROOF_SUCCESS,
          loading: false,
          message: 'Attachment downloaded successfully.'
        });
        if (result.url) {
          window.open(result.url, '_blank');
          // window.location.href = result.url;
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.DOWNLOAD_MANUAL_RECON_PROOF_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.DOWNLOAD_MANUAL_RECON_PROOF_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.DOWNLOAD_MANUAL_RECON_PROOF_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* editMerchantSettlementPaymentChannels() {
  yield takeEvery('EDIT_MERCHANT_SETTLEMENT_PAYMENT_CHANNELS', function* ({ urls, payload }) {
    try {
      yield put({
        type: actions.EDITING_MERCHANT_SETTLEMENT_PAYMENT_CHANNELS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();

      let addendumData = [];
      if (
        payload &&
        payload.addendum_files &&
        payload.addendum_files.length === urls.addendum_files.length
      ) {
        const dataFile = payload.addendum_files;
        dataFile.forEach(file => {
          if (urls.addendum_files.some(str => str.includes(file.name))) {
            let getURL = urls.addendum_files.find(str => str.includes(file.name));
            if (getURL) {
              uploadFileToS3(getURL, file);
              let currentObj = {
                name: file.name,
                file_type: file.file_type
              };
              addendumData.push(currentObj);
            }
          }
        });
      }
      const addendumLength = (urls?.addendum_files ?? []).length;

      yield delay(addendumLength * 1000);

      const apiResult = yield editMerchantSettlementPaymentChannelsAPI(
        {
          ...payload,
          addendum_files: addendumData
        },
        roleHeaderAuth
      );

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.EDIT_MERCHANT_SETTLEMENT_PAYMENT_CHANNELS_SUCCESS,
          loading: false,
          message: result.message
        });
        if (payload?.merchant_settlement_cycle_id) {
          yield put({
            type: settlementActions.FETCH_MERCHANT_SETTLEMENT_PAYMENT_CHANNELS_BY_ID,
            payload: payload.merchant_settlement_cycle_id
          });
          yield put({
            type: actions.FETCH_SETTLEMENT_RATE_BY_ID,
            payload: payload.merchant_settlement_cycle_id
          });
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.EDIT_MERCHANT_SETTLEMENT_PAYMENT_CHANNELS_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.EDIT_MERCHANT_SETTLEMENT_PAYMENT_CHANNELS_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.EDIT_MERCHANT_SETTLEMENT_PAYMENT_CHANNELS_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* createTransactionDeletionRequest() {
  yield takeEvery(actions.CREATE_TRANSACTION_DELETION_REQUEST, function* ({ payload }) {
    try {
      yield put({
        type: actions.CREATING_TRANSACTION_DELETION_REQUEST,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield createTransactionDeletionRequestAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.CREATE_TRANSACTION_DELETION_REQUEST_SUCCESS,
          loading: false,
          message: result.message,
          data: result.data,
          payload: payload && payload.transaction
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.CREATE_TRANSACTION_DELETION_REQUEST_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.CREATE_TRANSACTION_DELETION_REQUEST_FAILED,
            message: result && result.message ? result.message : 'No transaction found.',
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.CREATE_TRANSACTION_DELETION_REQUEST_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchTransactionRequests() {
  yield takeEvery(actions.FETCH_TRANSACTION_REQUESTS, function* ({ payload, pagination }) {
    try {
      yield put({
        type: actions.FETCHING_TRANSACTION_REQUESTS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchTransactionRequestsAPI(payload, pagination, roleHeaderAuth);

      const result = apiResult.data;

      const finalData = result && result.data;


      if (result.success) {
        yield put({
          type: actions.FETCH_TRANSACTION_REQUESTS_SUCCESS,
          loading: false,
          result: finalData || result.data,
          pagination: result.pagination,
          filter: payload
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_TRANSACTION_REQUESTS_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false,
            result: null,
            filter: payload
          });
        } else {
          yield put({
            type: actions.FETCH_TRANSACTION_REQUESTS_FAILED,
            message: 'Failed to process request',
            loading: false,
            result: null,
            filter: payload
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_TRANSACTION_REQUESTS_FAILED,
        loading: false,
        message: 'Failed to process request',
        result: null,
        filter: payload
      });
    }
  });
}

export function* updateTransactionRequestStatus() {
  yield takeEvery(actions.UPDATE_TRANSACTION_REQUEST_STATUS, function* ({ payload, id }) {
    try {
      yield put({
        type: actions.UPDATING_TRANSACTION_REQUEST_STATUS,
        loading: true
      });
      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield updateTransactionRequestStatusAPI(payload, id, roleHeaderAuth);

      const result = apiResult.data;
      if (result.success) {
        yield put({
          type: actions.UPDATE_TRANSACTION_REQUEST_STATUS_SUCCESS,
          loading: false,
          message: result.message,
          result: result ? result.data : null
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.UPDATE_TRANSACTION_REQUEST_STATUS_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.UPDATE_TRANSACTION_REQUEST_STATUS_FAILED,
            message: result.message,
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.UPDATE_TRANSACTION_REQUEST_STATUS_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* createCategorizeFloatingTransactionRequest() {
  yield takeEvery(actions.CREATE_CATEGORIZE_FLOATING_TRANSACTION_REQUEST, function* ({ payload }) {
    try {
      yield put({
        type: actions.CREATING_CATEGORIZE_FLOATING_TRANSACTION_REQUEST,
        loading: true
      });

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield createCategorizeFloatingTransactionRequestAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.CREATE_CATEGORIZE_FLOATING_TRANSACTION_REQUEST_SUCCESS,
          loading: false,
          message: result.message,
          data: result.data,
          payload: payload && payload.transaction
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.CREATE_CATEGORIZE_FLOATING_TRANSACTION_REQUEST_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.CREATE_CATEGORIZE_FLOATING_TRANSACTION_REQUEST_FAILED,
            message: result && result.message ? result.message : 'No transaction found.',
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.CREATE_CATEGORIZE_FLOATING_TRANSACTION_REQUEST_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* createTaggingForReviewReconciledTransactionRequest() {
  yield takeEvery(actions.CREATE_TAGGING_FOR_REVIEW_RECONCILED_TRANSACTION_REQUEST, function* ({ payload }) {
    try {
      yield put({
        type: actions.CREATING_TAGGING_FOR_REVIEW_RECONCILED_TRANSACTION_REQUEST,
        loading: true
      });

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield createTaggingForReviewReconciledTransactionRequestAPI(
        payload,
        roleHeaderAuth
      );

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.CREATE_TAGGING_FOR_REVIEW_RECONCILED_TRANSACTION_REQUEST_SUCCESS,
          loading: false,
          message: result.message,
          data: result.data,
          payload: payload && payload.transaction
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.CREATE_TAGGING_FOR_REVIEW_RECONCILED_TRANSACTION_REQUEST_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.CREATE_TAGGING_FOR_REVIEW_RECONCILED_TRANSACTION_REQUEST_FAILED,
            message: result && result.message ? result.message : 'No transaction found.',
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.CREATE_TAGGING_FOR_REVIEW_RECONCILED_TRANSACTION_REQUEST_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* tagReconciledTransaction() {
  yield takeEvery(
    actions.TAG_RECONCILED_TRANSACTION,
    function* ({ payload }) {
      try {
        yield put({
          type: actions.TAGGING_RECONCILED_TRANSACTION,
          loading: true
        });

        const roleHeaderAuth = yield getRoleHeader();
        const apiResult = yield tagReconciledTransactionAPI(payload,roleHeaderAuth);

        const result = apiResult.data;

        if (result.success) {
          yield put({
            type: actions.TAG_RECONCILED_TRANSACTION_SUCCESS,
            loading: false,
            message: result.message,
            result: result.data ? result.data : [],
            payload: payload && payload.transaction
          });
        } else {
          if (result.status === 404) {
            yield put({
              type: actions.TAG_RECONCILED_TRANSACTION_FAILED,
              message: `Endpoint ${result.title}`,
              loading: false
            });
          } else {
            yield put({
              type: actions.TAG_RECONCILED_TRANSACTION_FAILED,
              message: result && result.message ? result.message : 'No transaction found.',
              loading: false
            });
          }
        }
      } catch (error) {
        yield put({
          type: actions.TAG_RECONCILED_TRANSACTION_FAILED,
          message: 'Failed to process request',
          loading: false
        });
      }
    }
  );
}

export function* tagUnmatchedAsEndorsed() {
  yield takeEvery(actions.TAG_UNMATCHED_AS_ENDORSED, function* ({ payload }) {
    try {
      yield put({
        type: actions.TAGGING_UNMATCHED_AS_ENDORSED,
        loading: true
      });

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield tagUnmatchedAsEndorsedAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.TAG_UNMATCHED_AS_ENDORSED_SUCCESS,
          loading: false,
          message: result.message,
          result: result.data ? result.data : [],
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.TAG_UNMATCHED_AS_ENDORSED_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.TAG_UNMATCHED_AS_ENDORSED_FAILED,
            message: result && result.message ? result.message : 'No transaction found.',
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.TAG_UNMATCHED_AS_ENDORSED_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchApprovedFilteredDate() {
  yield takeEvery(actions.FETCH_ALL_APPROVED_FILTERED_DATE, function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_ALL_APPROVED_FILTERED_DATE,
        loading: true
      });

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchApprovedFilteredDateAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_ALL_APPROVED_FILTERED_DATE_SUCCESS,
          loading: false,
          message: result.message,
          result: result.data ? result.data : []
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_ALL_APPROVED_FILTERED_DATE_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.FETCH_ALL_APPROVED_FILTERED_DATE_FAILED,
            message: result && result.message ? result.message : 'No Approved Date found.',
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_ALL_APPROVED_FILTERED_DATE_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* notifyUnreconciledTransactions() {
  yield takeEvery(
    actions.NOTIFY_UNRECONCILED_TRANSACTIONS,
    function* ({ payload }) {
      try {
        yield put({
          type: actions.NOTIFYING_UNRECONCILED_TRANSACTIONS,
          loading: true
        });

        const roleHeaderAuth = yield getRoleHeader();
        const apiResult = yield notifyUnreconciledTransactionsAPI(
          payload,
          roleHeaderAuth
        );

        const result = apiResult.data;

        if (result.success) {
          yield put({
            type: actions.NOTIFY_UNRECONCILED_TRANSACTIONS_SUCCESS,
            loading: false,
            message: result.message
          });
        } else {
          if (result.status === 404) {
            yield put({
              type: actions.NOTIFY_UNRECONCILED_TRANSACTIONS_FAILED,
              message: `Endpoint ${result.title}`,
              loading: false
            });
          } else {
            yield put({
              type: actions.NOTIFY_UNRECONCILED_TRANSACTIONS_FAILED,
              message: result && result.message ? result.message : 'Failed to notify unreconciled transactions.',
              loading: false
            });
          }
        }
      } catch (error) {
        yield put({
          type: actions.NOTIFY_UNRECONCILED_TRANSACTIONS_FAILED,
          message: 'Failed to process request',
          loading: false
        });
      }
    }
  );
}

export function* fetchApprovedFilteredDatePChannelDetails() {
  yield takeEvery(actions.FETCH_APPROVED_FILTERED_DATE_DETAILS, function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_APPROVED_FILTERED_DATE_DETAILS,
        loading: true
      });

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchApprovedFilteredDatePChannelDetailsAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_APPROVED_FILTERED_DATE_DETAILS_SUCCESS,
          loading: false,
          message: result.message,
          result: result.data ? result.data : {}
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_APPROVED_FILTERED_DATE_DETAILS_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.FETCH_APPROVED_FILTERED_DATE_DETAILS_FAILED,
            message:
              result && result.message
                ? result.message
                : 'Failed to fetch approved date pchannel transactions.',
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_APPROVED_FILTERED_DATE_DETAILS_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* fetchUnreconciledPTIGroupMerchant() {
  yield takeEvery(actions.FETCH_UNRECONCILED_PTI_GROUP_MERCHANT, function* ({ payload }) {
    try {
      yield put({
        type: actions.FETCHING_UNRECONCILED_PTI_GROUP_MERCHANT,
        loading: true
      });

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield fetchUnreconciledPTIGroupMerchantAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.FETCH_UNRECONCILED_PTI_GROUP_MERCHANT_SUCCESS,
          loading: false,
          message: result.message,
          result: result.data ? result.data : null
        });
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.FETCH_UNRECONCILED_PTI_GROUP_MERCHANT_FAILED,
            message: `Endpoint ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.FETCH_UNRECONCILED_PTI_GROUP_MERCHANT_FAILED,
            message:
              result && result.message
                ? result.message
                : 'Failed to fetch unreconciled pti group merchant data',
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.FETCH_UNRECONCILED_PTI_GROUP_MERCHANT_FAILED,
        message: 'Failed to process request',
        loading: false
      });
    }
  });
}

export function* generateSummaryReconciliationReportFile() {
  yield takeEvery(
    actions.GENERATE_SUMMARY_RECONCILIATION_REPORT,
    function* ({ payload }) {
      try {
        yield put({
          type: actions.GENERATING_SUMMARY_RECONCILIATION_REPORT,
          loading: true
        });

        const roleHeaderAuth = yield getRoleHeader();
        const apiResult = yield generateSummaryReconciliationReportFileAPI(
          payload,
          roleHeaderAuth
        );

        const result = apiResult.data;

        if (result.success) {
          yield put({
            type: actions.GENERATE_SUMMARY_RECONCILIATION_REPORT_SUCCESS,
            loading: false,
            message: result.message
          });
        } else {
          yield put({
            type: actions.GENERATE_SUMMARY_RECONCILIATION_REPORT_FAILED,
            loading: false,
            message: result.message
          });
        }
      } catch (error) {
        yield put({
          type: actions.GENERATE_SUMMARY_RECONCILIATION_REPORT_FAILED,
          loading: false,
          message: 'Failed to process request'
        });
      }
    }
  );
}

export function* downloadGeneratedReconciliationSummaryReport() {
  yield takeEvery(
    actions.DOWNLOAD_GENERATED_SUMMARY_RECONCILIATION_REPORT,
    function* ({ payload }) {
      try {
        yield put({
          type: actions.DOWNLOADING_GENERATED_SUMMARY_RECONCILIATION_REPORT,
          loading: true
        });

        const roleHeaderAuth = yield getRoleHeader();
        const apiResult = yield downloadGeneratedReconciliationSummaryReportAPI(
          payload,
          roleHeaderAuth
        );

        const result = apiResult.data;

        if (result.success) {
          yield put({
            type: actions.DOWNLOAD_GENERATED_SUMMARY_RECONCILIATION_REPORT_SUCCESS,
            loading: false,
            message: result.message
          });

          if (result.url) {
            window.open(result.url, '_blank');
          }
        } else {
          yield put({
            type: actions.DOWNLOAD_GENERATED_SUMMARY_RECONCILIATION_REPORT_FAILED,
            loading: false,
            message: result.message
          });
        }
      } catch (error) {
        yield put({
          type: actions.DOWNLOAD_GENERATED_SUMMARY_RECONCILIATION_REPORT_FAILED,
          loading: false,
          message: 'Failed to process request'
        });
      }
    }
  );
}

export function* fetchGeneratedReconciliationSummaryReportFiles() {
  yield takeEvery(
    actions.FETCH_GENERATED_RECONCILIATION_SUMMARY_REPORT_FILES,
    function* ({ payload, pagination }) {
      try {
        yield put({
          type: actions.FETCHING_GENERATED_RECONCILIATION_SUMMARY_REPORT_FILES,
          loading: true
        });

        const roleHeaderAuth = yield getRoleHeader();
        const apiResult = yield fetchGeneratedReconciliationSummaryReportFilesAPI(
          payload,
          pagination,
          roleHeaderAuth
        );

        const result = apiResult.data;

        if (result.success) {
          yield put({
            type: actions.FETCH_GENERATED_RECONCILIATION_SUMMARY_REPORT_FILES_SUCCESS,
            loading: false,
            result: result ? result.data : null,
            pagination: result ? result.pagination : null
          });
        } else {
          yield put({
            type: actions.FETCH_GENERATED_RECONCILIATION_SUMMARY_REPORT_FILES_FAILED,
            loading: false
          });
        }
      } catch (error) {
        yield put({
          type: actions.FETCH_GENERATED_RECONCILIATION_SUMMARY_REPORT_FILES_FAILED,
          loading: false
        });
      }
    }
  );
}

export function* downloadUploadedBankFile() {
  yield takeEvery(actions.DOWNLOAD_UPLOADED_BANK_FILE, function* ({ payload }) {
    try {
      yield put({
        type: actions.DOWNLOADING_UPLOADED_BANK_FILE,
        loading: true
      });

      const roleHeaderAuth = yield getRoleHeader();
      const apiResult = yield downloadUploadedBankFileAPI(payload, roleHeaderAuth);

      const result = apiResult.data;

      if (result.success) {
        yield put({
          type: actions.DOWNLOAD_UPLOADED_BANK_FILE_SUCCESS,
          loading: false,
          message: result.message
        });

        if (result.url) {
          window.open(result.url, '_blank');
        }
      } else {
        if (result.status === 404) {
          yield put({
            type: actions.DOWNLOAD_UPLOADED_BANK_FILE_FAILED,
            message: `Endpoint: ${result.title}`,
            loading: false
          });
        } else {
          yield put({
            type: actions.DOWNLOAD_UPLOADED_BANK_FILE_FAILED,
            message: result.message
              ? result.message
              : 'Failed to download uploaded file remittance',
            loading: false
          });
        }
      }
    } catch (error) {
      yield put({
        type: actions.DOWNLOAD_UPLOADED_BANK_FILE_FAILED,
        message: 'Failed to download uploaded file remittance',
        loading: false
      });
    }
  });
}





function* getRoleHeader() {
  const state = yield select();
  const identity = state.Auth.identity;
  const currentPage = state.App.currentPage;
  const currentAction = state.App.currentAction;
  if (currentAction) {
    return `${identity.role_id}:${currentPage.id}:${currentAction.id}`;
  } else {
    return `${identity.role_id}:${currentPage.id}`;
  }
}
// TO-DO: Case logs in finance module
function fetchCaseLogsAPI(data, pagination, roleAuth) {
  return get(
    `get/case-logs/${data}`,
    null,
    pagination ? pagination : { page: 0, limit: 10 },
    null,
    null,
    roleAuth
  );
}
async function uploadFileToS3(url, payload) {
  return await fetch(url, {
    method: 'PUT',
    headers: {
      'Content-Type': payload.file.type
    },
    body: payload.file
  });
}
function sendDiscussionAPI(data, roleAuth) {
  return post(`send/discussion`, data, null, null, roleAuth);
}
function searchRequest(data) {
  return post(`elastictransactions/new/search_transaction`, data);
}
function fetchResponseCodeAPI(roleAuth) {
  return get(`get-all/response-code`, null, null, null, null, roleAuth);
}
function addResponseCodeAPI(data, roleAuth) {
  return post(`add/response-code`, data, null, null, roleAuth);
}
function editResponseCodeAPI(data, id, roleAuth) {
  return PUT(`edit/response-code/${id}`, data, null, roleAuth);
}
function editSettlementRateAPI(data, id, roleAuth) {
  return PUT(`merchant-settlement-rate/${id}`, data, null, roleAuth);
}
function fetchSecurityCodeAPI(roleAuth) {
  return get(`get-all/security-code`, null, null, null, null, roleAuth);
}
function addSecurityCodeAPI(data, roleAuth) {
  return post(`add/security-code`, data, null, null, roleAuth);
}
function editSecurityCodeAPI(data, id, roleAuth) {
  return PUT(`edit/security-code/${id}`, data, null, roleAuth);
}
function fetchBillingDetailsAPI(id, roleAuth) {
  return get(`get/billing-details/${id}`, null, null, null, null, roleAuth);
}
function fetchBillerDetailsAPI(roleAuth) {
  return get(`get-all/biller`, null, null, null, null, roleAuth);
}
// TO-DO: Finance module recon
function fetchSettlementReportDataAPI(data, pagination, roleAuth) {
  return post(`get/reconciled-file`, data, pagination, null, roleAuth);
}
function fetchAllMonthReconciledReportDataAPI(data, pagination,roleAuth) {
  return post(`get/monthly-reconciled-file`, data, pagination,null, roleAuth);
}
function fetchUnreconciledReportDataAPI(data, pagination, roleAuth) {
  return post(`get/unreconciled-file`, data, pagination, null, roleAuth);
}
// - end
function unsubscribeNotificationCredentialAPI(data, id, roleAuth) {
  return PUT(`edit/notification-preference/${id}`, data, null, roleAuth);
}
function fetchReconciliationDataByPChannelIDAPI(data, roleAuth) {
  return post(`get/reconciliation-count`, data, null, null, roleAuth);
}
function fetchCollatedDataByPChannelAPI(data, roleAuth) {
  return post(`compare/reconciliation-data`, data, null, null, roleAuth);
}
function fetchBillingDataByMerchantIDAPI(data, roleAuth) {
  return post(`get/billing-data`, data, null, null, roleAuth);
}
function addBillingDataByMerchantIDAPI(data, roleAuth) {
  return post(`add/billing-data`, data, null, null, roleAuth);
}
function updateCaseDetailsAPI(data, id, roleAuth) {
  return PUT(`update/case-details/${id}`, data, null, roleAuth);
}
function analyzeCollateDataAPI(data, roleAuth) {
  return post(`analyze/consolidate/reconciliation-data-by-channel`, data, null, null, roleAuth);
}
function generateReportDataAPI(data, roleAuth) {
  return post(`generate-reconciled-file`, data, null, null, roleAuth);
}
function downloadSettlementReportDataAPI(id, roleAuth) {
  return get(`download-reconciled-file/${id}`, null, null, null, null, roleAuth);
}
function generateMonthReportDataAPI(data, roleAuth) {
  return post(`generate-monthly-reconciled-file`, data, null, null, roleAuth);
}
function downloadMonthlyReconciledReportAPI(id, roleAuth) {
  return get(`download-monthly-reconciled-file/${id}`, null, null, null, null, roleAuth);
}
function downloadCaseAttachmentAPI(id, roleAuth) {
  return get(`download-case-attachment-file/${id}`, null, null, null, null, roleAuth);
}
function downloadUnreconciledReportDataAPI(id, roleAuth) {
  return get(`download-unreconciled-file/${id}`, null, null, null, null, roleAuth);
}
function fetchCaseDetailsAPI(payload, roleAuth) {
  return get(`get/case-details/${payload}`, null, null, null, null, roleAuth);
}
function generateUnreconciledReportDataAPI(data, roleAuth) {
  return post(`generate-unreconciled-file`, data, null, null, roleAuth);
}
function checkCollateDataFromDevAPI(data, roleAuth) {
  return post(`check/reconciliation-data-by-channel-from-dev`, data, null, null, roleAuth);
}
function checkCollateDataFromPaygateAPI(data, roleAuth) {
  return post(`check/reconciliation-data-by-channel-from-paygate`, data, null, null, roleAuth);
}
function fetchFinanceDashboardDataAPI(payload, roleAuth) {
  return post(`get/finance-dashboard-data`, payload, null, null, roleAuth);
}
function checkCollateDataAPI(data, roleAuth) {
  return post(`check/transaction-data`, data, null, null, roleAuth);
}
function fetchAllReconciledDataAPI(data, pagination, roleAuth) {
  return post(`get/reconciled-transactions`, data, pagination, null, roleAuth);
}
function inviteCaseMemberAPI(data, roleAuth) {
  return post(`invite/case-member`, data, null, null, roleAuth);
}
function escalateTransactionDataAPI(data, roleAuth) {
  return post(`escalate/transactions`, data, null, null, roleAuth);
}
function likeDiscussionAPI(id, data, roleAuth) {
  return PUT(`like/discussion/${id}`, data, null, roleAuth);
}
function fetchAllCasesAPI(data, roleAuth) {
  return post(`fetch/cases`, data, null, null, roleAuth);
}
function getURLsForCaseFilesAPI(key, data, roleAuth) {
  return post(`get/utility/multiple-presigned-s3-url-with-key/${key}`, data, null, null, roleAuth);
}
function getURLsForAddendumFilesAPI(data, roleAuth) {
  return post(`post/utility/multiple-presigned-s3-url-with-key`, data, null, null, roleAuth);
}
function fetchCaseDiscussionAPI(data, roleAuth) {
  return post(`fetch/case-discussion`, data, null, null, roleAuth);
}
function fetchUploadedBankFileApi(data, pagination, roleAuth) {
  return post(`get-all/upload/bank-file`, data, pagination, null, roleAuth);
}
function fetchUploadedBankTransactionApi(id, data, pagination, roleAuth) {
  return post(`get-all/upload/bank-transaction/${id}`, data, pagination, null, roleAuth);
}
function updateBankRemittanceAPI(data, roleAuth) {
  return post(`remit/bank-transaction`, data, null, null, roleAuth);
}
function updateBankTransactionAPI(data, roleAuth) {
  return PUT(`update/bank-transaction`, data, null, null, roleAuth);
}
function updateBankFileAPI(id, data, roleAuth) {
  return PUT(`edit/upload/bank-file/${id}`, data, null, null, roleAuth);
}
function generateBankTrxStatisticsAPI(id, data, roleAuth) {
  return post(`generate/bank-transaction-statistics/${id}`, data, null, null, roleAuth);
}
function fetchAllChannelScheduleAPI(roleAuth) {
  return get(`get-all/remitting-channel-schedule`, null, null, null, null, roleAuth);
}
function addChannelScheduleAPI(data, roleAuth) {
  return post(`add/remitting-channel-schedule`, data, null, null, roleAuth);
}
function editChannelScheduleAPI(id, data, roleAuth) {
  return PUT(`edit/remitting-channel-schedule/${id}`, data, null, null, roleAuth);
}
function deleteBankFileAndTransactionsAPI(id, roleAuth) {
  return DELETE(`delete/upload-data/${id}`, null, null, roleAuth);
}
function fetchTrxList(data) {
  delete data.currentList;
  return post(`get/transactions`, data, null);
}
function fetchTrxDetails(data) {
  delete data.currentList;
  return post(`get/transaction_details`, data);
}
function fetchOtcTransactionsAPI(data, roleAuth) {
  return post(`get/finance-otc-transactions`, data, null, null, roleAuth);
}
function updateOtcTransactionsAPI(data, roleAuth) {
  return PUT(`update/finance-otc-transactions`, data, null, null, roleAuth);
}
function getDownloadCSV(payload) {
  return post(`download/transactions`, payload);
  // return post(`transactions/download_csv`, payload);
}
function fetchMerchants() {
  return get(`get/trx_merchant`);
}
function fetchPrevDownloads(data) {
  return post(`get/download_trx`, data);
}
function fetchExcelList(data) {
  return post(`get/download_trx_excel`, data);
}
function getDownloadReport(filename, roleAuth) {
  return get(`get/download_trx_ready/${filename}`, roleAuth);
}
function fetchAllFinanceOperationsAPI(data, roleAuth) {
  return post(`fetch/finance-operations`, data, null, null, roleAuth);
}
function fetchFinanceOperationsByIDAPI(id, roleAuth) {
  return get(`get-by-id/finance-operations/${id}`, null, null, null, null, roleAuth);
}
function fetchReversalRequestByIDAPI(id, roleAuth) {
  return get(`get-by-id/reversal-request/${id}`, null, null, null, null, roleAuth);
}
function fetchFinanceOperationsLogsAPI(data, pagination, roleAuth) {
  return get(
    `get/finance-operations-logs/${data}`,
    pagination ? pagination : { page: 0, limit: 20 },
    null,
    null,
    null,
    roleAuth
  );
}
function downloadVatExemptionFileOperationsAPI(id, operationsID, roleAuth) {
  return get(
    `download-vat-exemption-file-finance-operations/${id}/${operationsID}`,
    null,
    null,
    null,
    null,
    roleAuth
  );
}
function downloadPaymentProofFileOperationsAPI(id, operationsID, roleAuth) {
  return get(
    `download-payment-proof/finance-operations/${id}/${operationsID}`,
    null,
    null,
    null,
    null,
    roleAuth
  );
}
function approveVatExemptionFileAPI(data, id, roleAuth) {
  return PUT(`approve/finance-operations/vat-exemption/${id}`, data, null, roleAuth);
}
function rejectVatExemptionFileAPI(data, id, roleAuth) {
  return PUT(`reject/finance-operations/vat-exemption/${id}`, data, null, roleAuth);
}
function confirmPaymentProofFileAPI(data, id, roleAuth) {
  return PUT(`confirm-payment-proof/finance-operations/${id}`, data, null, roleAuth);
}
function sendMerchantInvoiceFileAPI(data, roleAuth) {
  return PUT(`send/finance-operations/invoice`, data, null, roleAuth);
}
function viewConfidentialBankDetailsAPI(data, roleAuth) {
  return post(`ob-decryption`, data, null, null, roleAuth);
}
function editInvoiceAPI(data, id, roleAuth) {
  return PUT(`finance-operations/edit-invoice/${id}`, data, null, roleAuth);
}
function viewInvoicePDFAPI(id, roleAuth) {
  return get(`view-invoice-pdf/${id}`, null, null, null, null, roleAuth);
}
function viewVatReversalAttachmentAPI(id, roleAuth) {
  return get(`view-vat-reversal-attachment/${id}`, null, null, null, null, roleAuth);
}
function viewPaymentProofPDFAPI(id, roleAuth) {
  return get(`view-payment-proof-pdf/${id}`, null, null, null, null, roleAuth);
}
function requestInvoiceApprovalAPI(data, roleAuth) {
  return PUT(`finance-operations/request-invoice-approval`, data, null, roleAuth);
}
function requestVatReversalAPI(data, roleAuth) {
  return post(`finance-operations/request-vat-exempt-reversal`, data, null, roleAuth);
}
function approveVatExemptReversalAPI(data, id, roleAuth) {
  return PUT(`approve/finance-operations/vat-exempt-reversal/${id}`, data, null, roleAuth);
}
function rejectVatExemptReversalAPI(data, id, roleAuth) {
  return PUT(`reject/finance-operations/vat-exempt-reversal/${id}`, data, null, roleAuth);
}
function fetchAllFinanceUsersAPI(roleAuth) {
  return post(`fetch/finance-users`, null, null, null, roleAuth);
}
function rejectInvoiceAPI(data, roleAuth) {
  return PUT(`reject/finance-operations/invoice`, data, null, roleAuth);
}
function approveInvoiceAPI(data, roleAuth) {
  return PUT(`approve/finance-operations/invoice`, data, null, roleAuth);
}
function getURLsForReversalAttachmentAPI(key, data, roleAuth) {
  return post(`get/utility/multiple-presigned-s3-url-with-key/${key}`, data, null, null, roleAuth);
}
function getURLsForMerchantFilesAPI(key, data, roleAuth) {
  return post(`get/utility/multiple-presigned-s3-url-with-key/${key}`, data, null, null, roleAuth);
}
function managePaymentProofFilesAPI(data, id, roleAuth) {
  return PUT(`manage-payment-proof/finance-operations/${id}`, data, null, roleAuth);
}
function fetchAllSettlementCycleDataAPI(data, pagination, roleAuth) {
  return post(`get-all/merchant-settlement-cycle`, data, pagination, null, roleAuth);
}
function fetchSettlementCycleByIDAPI(id, roleAuth) {
  return get(`get-by-id/finance-operations/${id}`, null, null, null, null, roleAuth);
}
function fetchSettlementRateByIDAPI(id, roleAuth) {
  return get(`merchant-settlement-rate/${id}`, null, null, null, null, roleAuth);
}
function addSettlementCycleAPI(data, roleAuth) {
  return post(`add/merchant-settlement-cycle`, data, null, null, roleAuth);
}
function editSettlementCycleAPI(data, id, roleAuth) {
  return PUT(`edit/merchant-settlement-cycle/${id}`, data, null, roleAuth);
}

function createBillingAdditionalFeeAPI(data, roleAuth) {
  return post(`add/merchant-billing-config`, data, null, null, roleAuth);
}

function fetchAllBillingAdditionalFeeDataAPI(data, roleAuth) {
  return post(`get-all/merchant-billing-config`, data, null, null, roleAuth);
}

function fetchBillingAdditionalFeeByIDAPI(id, roleAuth) {
  return get(`fetch-merchant-billing-config/${id}`, null, null, null, null, roleAuth);
}

function updateBillingAdditionalFeeAPI(data, roleAuth) {
  return PUT(`edit/merchant-billing-config`, data, null, roleAuth);
}

function fetchBillingConfigurationLogsAPI(data, pagination, roleAuth) {
  return get(
    `get/finance-billing-config-logs/${data}`,
    null,
    pagination ? pagination : { page: 0, limit: 20 },
    null,
    null,
    roleAuth
  );
}

function generateSummaryBreakdownReportAPI(data, roleAuth) {
  return post(`reconciliation/generate-summary-breakdown-report`, data, null, roleAuth);
}

function generateSummaryBreakdownReportV2API(data, roleAuth) {
  return post(`settlement/v2/generate-summary-breakdown-report`, data, null, roleAuth);
}

function rejectChangeRequestRatesAPI(data, roleAuth) {
  return post(`reject/change-request-rates`, data, null, null, roleAuth);
}
function approveChangeRequestRatesBySalesAPI(data, roleAuth) {
  return post(`approve-by-sales-head/change-request-rates`, data, null, null, roleAuth);
}
function approveChangeRequestRatesByFinanceAPI(data, roleAuth) {
  return post(`approve-by-finance-head/change-request-rates`, data, null, null, roleAuth);
}

function editMerchantPaymentChannelSettlementAPI(data, roleAuth) {
  return PUT(`settlement/edit-merchant-payment-channel`, data, null, roleAuth);
}
function createChangeRequestRatesAPI(data, roleAuth) {
  return PUT(`settlement/create-change-request-rates`, data, null, roleAuth);
}

function fetchFeeHistoryAPI(data, pagination, roleAuth) {
  return get(
    `merchant-settlement-cycle/${data}/fee-history`,
    null,
    pagination ? pagination : { page: 0, limit: 20 },
    null,
    null,
    roleAuth
  );
}

function downloadAddendumDocumentAPI(id, payload, roleAuth) {
  return get(
    `download-addendum-document/merchant-settlement-cycle/${id}/${payload}`,
    null,
    null,
    null,
    null,
    roleAuth
  );
}

function fetchAllGeneratedSettlementSummaryReportDataAPI(data, pagination, roleAuth) {
  return post(`get-all/generated-settlement-summary-reports`, data, pagination, null, roleAuth);
}

function downloadSummaryReportAPI(id, roleAuth) {
  return get(`download-settlement-summary-report/${id}`, null, null, null, null, roleAuth);
}

function saveSummaryBreakdownReportPchannelFilterAPI(data, roleAuth) {
  return post(`save/summary-breakdown-report-pchannel-filter`, data, null, null, roleAuth);
}

function fetchSummaryBreakdownReportPchannelFilterAPI(data, roleAuth) {
  return get(`fetch/summary-breakdown-report-pchannel-filter`, data, null, null, roleAuth);
}

function tagAsFloatingAPI(data, roleAuth) {
  return post(`tag/floating/transaction-data`, data, null, null, roleAuth);
}

function findSingleTransactionLooselyAPI(data, roleAuth) {
  return post(`find/single-transaction-data`, data, null, null, roleAuth);
}

function confirmManualReconAPI(data, roleAuth) {
  return post(`confirm-manual-recon`, data, null, null, roleAuth);
}

function downloadManualReconProofAPI(data, roleAuth) {
  return post(`download-manual-recon-proof-attachment`, data, null, null, roleAuth);
}

function editMerchantSettlementPaymentChannelsAPI(data, roleAuth) {
  return PUT(`settlement/update-payment-channels`, data, null, roleAuth);
}

function createTransactionDeletionRequestAPI(data, roleAuth) {
  return post(`transaction-requests`, data, null, null, roleAuth);
}

function fetchTransactionRequestsAPI(data, pagination, roleAuth) {
  return post(`get/transaction-requests`, data, pagination, null, roleAuth);
}

function updateTransactionRequestStatusAPI(data, id, roleAuth) {
  return PUT(`transaction-requests/${id}/status`, data, null, roleAuth);
}

function createCategorizeFloatingTransactionRequestAPI(data, roleAuth) {
  return post(`transaction-requests`, data, null, null, roleAuth);
}

function createTaggingForReviewReconciledTransactionRequestAPI(data, roleAuth) {
  return post(`transaction-requests`, data, null ,null, roleAuth)
}

function tagReconciledTransactionAPI(data, roleAuth) {
  return post(`transaction-tag-reconciled`, data, null, null, roleAuth)
}

function tagUnmatchedAsEndorsedAPI(data, roleAuth) {
  return post(`transaction-tag-unmatched`, data, null, null, roleAuth)
}

function fetchApprovedFilteredDateAPI(data, roleAuth) {
  return post(`get/transaction-list-of-approved-filtered-date`, data, null , null , roleAuth)
}

function notifyUnreconciledTransactionsAPI(data, roleAuth) {
  return post(`notify/reviewed-transaction`, data, null, null, roleAuth)
}

function fetchApprovedFilteredDatePChannelDetailsAPI(data, roleAuth) {
  return post(`get/approved-pchannel-date`, data, null, null, roleAuth)
}

function fetchUnreconciledPTIGroupMerchantAPI(data, roleAuth) {
  return post (`get/unreconciled-pti-group-by-merchants`, data, null, null, roleAuth)
}

function generateSummaryReconciliationReportFileAPI(data, roleAuth) {
  return post(`generate/summary-reconciliation-report`, data, null, null ,roleAuth)
}

function downloadGeneratedReconciliationSummaryReportAPI(id, roleAuth) {
  return get(
    `download/generated-summary-reconciliation-report-file/${id}`,
    null,
    null,
    null,
    null,
    roleAuth
  )
}

function fetchGeneratedReconciliationSummaryReportFilesAPI(data, pagination, roleAuth) {
  return post(`get/summary-reconciliation-report`, data, pagination, null, roleAuth)
}

function downloadUploadedBankFileAPI(data, roleAuth) {
  return post(`download/uploaded-bank-file`, data, null, null, roleAuth);
}

export default function* rootSaga() {
  yield all([
    fork(search),
    fork(fetchCaseLogs),
    fork(unsubscribeNotificationCredential),
    fork(fetchReconciliationDataByPChannelID),
    fork(fetchResponseCode),
    fork(fetchSecurityCode),
    fork(fetchBillingDataByMerchantID),
    fork(addBillingDataByMerchantID),
    fork(fetchBillingDetails),
    fork(updateCaseDetails),
    fork(fetchBillerDetails),
    fork(fetchCollatedData),
    fork(analyzeCollateData),
    fork(generateReportData),
    fork(generateMonthReportData),
    fork(getURLSforUploadedCaseFiles),
    fork(sendDiscussion),
    fork(likeDiscussion),
    fork(downloadCaseAttachment),
    fork(downloadSettlementReportData),
    fork(downloadMonthlyReconciledReport),
    fork(checkCollateDataFromDev),
    fork(checkCollateDataFromPaygate),
    fork(fetchSettlementReportData),
    fork(fetchAllMonthSettlementReportData),
    fork(fetchFinanceDashboardData),
    fork(checkCollateData),
    fork(fetchAllReconciledData),
    fork(generateUnreconciledReportData),
    fork(fetchCaseDetails),
    fork(inviteCaseMember),
    fork(fetchUnreconciledReportData),
    fork(downloadUnreconciledReportData),
    fork(escalateTransactionData),
    fork(fetchAllCases),
    fork(fetchCaseDiscussions),
    fork(fetchUploadedBankFiles),
    fork(fetchUploadedBankTransaction),
    fork(updateBankRemittance),
    fork(updateBankTransaction),
    fork(updateBankFile),
    fork(generateBankTrxStatistics),
    fork(fetchAllChannelSchedule),
    fork(addChannelSchedule),
    fork(updateChannelSchedule),
    fork(deleteBankFileAndTransactions),
    fork(getTrxList),
    fork(getTrxDetails),
    fork(fetchOtcTransactions),
    fork(updateOtcTransactions),
    fork(downloadCsv),
    fork(getTrxMerchants),
    fork(getPreviousDownloads),
    fork(getExcelDownloadList),
    fork(fetchDownloadReport),
    fork(addResponseCode),
    fork(editResponseCode),
    fork(changeResponseCodeStatus),
    fork(addSecurityCode),
    fork(editSecurityCode),
    fork(changeSecurityCodeStatus),
    fork(fetchAllFinanceOperations),
    fork(fetchFinanceOperationsByID),
    fork(fetchReversalRequestByID),
    fork(fetchFinanceOperationsLogs),
    fork(downloadVatExemptionFileOperations),
    fork(downloadPaymentProofFileOperations),
    fork(approveVatExemptionFile),
    fork(rejectVatExemptionFile),
    fork(getS3UrlsReversalAttachment),
    fork(getS3UrlsPaymentProof),
    fork(managePaymentProofFiles),
    fork(confirmPaymentProofFile),
    fork(viewConfidentialBankDetails),
    fork(editInvoice),
    fork(viewInvoicePDF),
    fork(viewVatReversalAttachment),
    fork(viewPaymentProofPDF),
    fork(requestInvoiceApproval),
    fork(requestVatExemptReversal),
    fork(approveVatExemptReversal),
    fork(rejectVatExemptReversal),
    fork(fetchAllFinanceUsers),
    fork(getS3UrlESignature),
    fork(rejectInvoice),
    fork(approveInvoice),
    fork(sendMerchantInvoiceFile),
    fork(fetchAllGeneratedSettlementSummaryReportData),
    fork(downloadSettlementSummaryReport),
    fork(generateSummaryBreakdownReport),
    fork(fetchAllSettlementCycleData),
    fork(fetchSettlementCycleByID),
    fork(addSettlementCycle),
    fork(editSettlementCycle),
    fork(editMerchantPaymentChannelSettlement),
    fork(fetchSettlementRateByID),
    fork(editSettlementRate),
    fork(getS3UrlsAddendumFile),
    fork(fetchFeeHistory),
    fork(rejectChangeRequestRates),
    fork(approveChangeRequestRatesBySales),
    fork(approveChangeRequestRatesByFinance),
    fork(downloadAddendumDocument),
    fork(createChangeRequestRates),
    fork(saveSummaryBreakdownReportPChannelFilter),
    fork(fetchSummaryBreakdownReportPChannelFilter),
    fork(createBillingAdditionalFee),
    fork(fetchAllBillingAdditionalFeeData),
    fork(fetchBillingAdditionalFeeByID),
    fork(updateBillingAdditionalFee),
    fork(fetchBillingConfigurationLogs),
    fork(tagAsFloating),
    fork(findSingleTransactionLoosely),
    fork(getURLSforUploadedReconProof),
    fork(confirmManualRecon),
    fork(downloadManualReconProof),
    fork(editMerchantSettlementPaymentChannels),
    fork(createTransactionDeletionRequest),
    fork(fetchTransactionRequests),
    fork(updateTransactionRequestStatus),
    fork(createCategorizeFloatingTransactionRequest),
    fork(createTaggingForReviewReconciledTransactionRequest),
    fork(tagReconciledTransaction),
    fork(tagUnmatchedAsEndorsed),
    fork(fetchApprovedFilteredDate),
    fork(notifyUnreconciledTransactions),
    fork(fetchApprovedFilteredDatePChannelDetails),
    fork(fetchUnreconciledPTIGroupMerchant),
    fork(generateSummaryBreakdownReportV2),
    fork(generateSummaryReconciliationReportFile),
    fork(downloadGeneratedReconciliationSummaryReport),
    fork(fetchGeneratedReconciliationSummaryReportFiles),
    fork(downloadUploadedBankFile)
  ]);
}
